
import React, { useContext, useState, useEffect, useRef } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import moment from "moment";
import { PostAPI } from "api/post";
import Wizard from './PageType-3.jsx';
import Card from "components/Card/Card.jsx";
import { isEmpty } from "components/Login/validator";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import SimpleReactValidator from 'simple-react-validator';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/animations/shift-toward-subtle.css';
import 'tippy.js/animations/shift-toward-extreme.css';
import { useTranslation } from 'react-i18next';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import ModalBox from '../components/ModalBox/ModalBox';
import ModalTreeBox from '../components/ModalBox/ModalTreeBox';
import SortableTree, { getVisibleNodeCount } from "react-sortable-tree"
import FileExplorerTheme from 'react-sortable-tree-theme-full-node-drag';
import treeData from 'views/treeData';
import 'react-sortable-tree/style.css';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import { getWizardDataService } from "../services/wizardDataService";
import DataGrid from "components/DataGrid/DataGrid.js";
import ExpandRowGrid from "components/ExpandRowGrid/ExpandRowGrid.js";
import CommonTree from "components/CommonTree/CommonTree.js";
import { WizardDataContext } from "context/WizardDataContext";
import globaldata from "../constants/globaldata.json";
import PaginationDropdown from "../components/PaginationDropdown/PaginationDropdown.js";
import ErrorFallback from "../components/ErrorFallback/ErrorFallback.js";
import { getStatusAlert, handleNetworkErrors,getReportTotalQuanties, transformColumns } from "../utilities/CommonUtils.js";
import { icon } from "@fortawesome/fontawesome-svg-core";
const cookies = new Cookies();
let urlhost = window.location.host;
const domain = urlhost.split('.');
const subDomain = domain[1] +"."+ domain[2];

const Role = props => {
  const { t, i18n } = useTranslation();
  const initialValue = [{displayValue: `${t('inputTypes.pleaseSelect')}`, value: ''}];
  let [featureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ?  globaldata.unDefined : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState( globaldata.unDefined);
  let[commonTitle, setCommonTitle] = useState("");
  let [renderComponent, setRenderComponent] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [title1, setTitle1] = useState('')
  let [uniqueid, setuniqueid] = useState();
  let [expandTableLoader, setExpandTableLoader] = useState(false);
  let [expandChildTableLoader, setExpandChildTableLoader] = useState(false);
  let[key, setKey] = useState()
  let[key1, setKey1] = useState()
  let [expRes, setExpRes] = useState();
  let [line,setLine] = useState()
  let [table, setTable] = useState(false);
  let [expand, setExpand] = useState([])
  const [wareIds, setWareIds] = useState([])
  let [values, setValues] = useState();
  let [headers, setHeaders] = useState(null);
  let [modalTitle, setModalTitle] = useState('');
  let [saveUrl, setSaveUrl] = useState();
  let [extraId, setextraId] = useState();
  let [searchInputValue, setsearchInputValue] = useState('');
  let [imagePath, setImagePath] = useState();
  let[array,setArray] = useState([])
  const [showFilter, setshowFilter] = useState(false);
  let [invValidation,setInvValidation] = useState(true)
  const [showCSearch, setshowCSearch] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [ShowModald3, setShowModald3] = useState(false);
  const [treevalue, setTreevalue] = useState( treeData );
  const [changeTreeValue, setChangeTreeValue] = useState(false);
  const [childRow, setChildRow] = useState(1);
  const [wareId, setWareId] = useState()
  let [loadTableData, setloadTableData] = useState(true);
  let [page, setpage] = useState(1);
  let [expPage, setExpPage] = useState(1);
  let [expChildPage, setExpChildPage] = useState(1);
  let [val1, setVal1] = useState();
  let [val2, setVal2] = useState();
  let [sizePerPage, setsizePerPage] = useState(10);
  let [expSizePerPage, setExpSizePerPage] = useState(10);
  let [expChildSizePerPage, setExpChildSizePerPage] = useState(10);
  let [totalrecords, settotalrecords] = useState();
  let [modalType, setmodalType] = useState(`${t(globaldata.add)}`);
  let [modalgetURL, setmodalgetURL] = useState('');
  let [productsData, setproductsData] = useState([]);
  let [modalWidth, setModalWidth] = useState();
  let [dropDownApi, setDropDownApi] = useState();
  let [productId, setProductId]= useState();
  let [deliveryId, setDeliveryId]= useState();
  let [locationTypeId, setLocationTypeId]= useState();
  let [locationId, setLocationId]= useState();
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [uniqueId, setuniqueId] = useState();
  let[response, setResponse] = useState();
  const [selectOption, setSelectOption] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  let [expandRowTotalrecords, setExpRowTotalrecords] = useState()
  let [expandChildRowTotalrecords, setExpChildRowTotalrecords] = useState()
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [showExpandColumn, setshowExpandColumn] = useState(false);
  let [addPermission, setAddPermission] = useState(false)
  let [addPermission1, setAddPermission1] = useState(false)
  let [addChildPermission, setAddChildPermission] = useState(false)
  let [addPermission2, setAddPermission2] = useState(false)
  let [addPermission3, setAddPermission3] = useState(false)
  let [addPermission4, setAddPermission4] = useState(false)
  let [importPermission, setimportPermission] = useState(false)
  let [importPermission1, setimportPermission1] = useState(false)
  let [importPermission2,setimportPermission2] = useState(false)
  let [importPermission3,setimportPermission3] = useState(false)
  let [exportPermission, setexportPermission] = useState(false)
  let [exportPermission1, setexportPermission1] = useState(false)
  let [exportPermission2, setexportPermission2] = useState(false)
  let [exportPermission3, setexportPermission3] = useState(false)
  const [addLocationPermission, setAddLocationPermission] = useState(false);
  const [bulkPicklistPermission, setBulklistPermission] = useState(false)
  const [masterDeliveryPermission, setMasterDeliveryPermission] = useState(false);
  let[onlyOneExpanding,setonlyOneExpanding]=useState(false);
  let[expandByColumnOnly,setexpandByColumnOnly] = useState(false)
  let[onExpandable,setonExpandable] = useState(true)
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  const [isEditOpen, setIsEditOpen] = useState(false)
  let [isLoader, setIsLoader] = useState(false)
  const [pageStartFrom, setPageStartFrom] = useState(1);
  const [timeStamp, setTimeStamp] = useState("");
  const searchContainerRef = useRef(null);
  const customerIDs = ["16","17"];
  const userRole_name = cookies.get("userRole_name").replace(/\s/g, "")  === 'WhitelistAdmin'  ? true : false
  const checkBoxObj = {
    whitelist_check : {
        elementType: "checkbox",
        elementConfig: {
            type: "checkbox",
            placeholder: "WhiteList"
        },
        id: "whitelist_check",
        value: 0,
        label: "WhiteList",
        validate: {
            required: false,
            rules: "required"
        },
        update: {
            "required": false
        }
    }
}
  const [isDragAndDrop, setIsDragAndDrop] = useState(null)
  const [isSelectedRow, setIsSelectedRow] = useState([])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isPageChanged, setIsPageChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  
  const [isApproved, setIsApproved] = useState(null);
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [staticModalformValues, setStaticModalformValues] = useState();
  const [isFilterLoader, setIsFilterLoader] = useState(false);
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
})
  let centeredDiv = {
    display: 'flex',
    alignItems: 'center',
    marginRight:'40%',
    justifyContent: 'center',
    height: '30vh'
}

  let headerData = {
     start_from: 0,
     customer_id:cookies.get(globaldata.customerId),
     user_id:cookies.get(globaldata.userId),
  }
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
  let dynamicParameters = {
    customer_id:cookies.get(globaldata.customerId),
    user_id:cookies.get(globaldata.userId),
    userLocation_id:cookies.get(globaldata.userLocationId),
    userRole_name:cookies.get(globaldata.userRoleName),
    language: currentLanguageCode === 'en' ? 'english' : 'chinese'
 }
 let [expandData, setExpData] = useState([])
 let [expChildData, setExpChildData] = useState([]);
  let [columns, setColumns] = useState([{ dataField: "dataFields.serialNo", text: "texts.serialNo" },
  { dataField: "dataFields.roleName", text: "texts.roleName" },
  { dataField: "dataFields.customerName", text: "texts.customerName" } ]);
  let [expandColumns, setExpColumns] = useState([{ dataField: "dataFields.serialNo", text: "texts.serialNo" },
  { dataField: "dataFields.roleName", text: "texts.roleName" },
  { dataField: "dataFields.customerName", text: "texts.customerName" }]);

  let [expChildColumns, setExpChildColumns] = useState([{ dataField: "dataFields.serialNo", text: "texts.serialNo" },
  { dataField: "dataFields.roleName", text: "texts.roleName" },
  { dataField: "dataFields.customerName", text: "texts.customerName" }]);

  let [formValues, setformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  let [localSearch, setLocalSearch] = useState(false);
  const count = getVisibleNodeCount({treeData:treevalue})
  const [disableRefreshIcon, setDisableRefreshIcon] = useState(false)
  const [fifoId, setFifoId] = useState()
  const [totalQuantities, setTotalQuanties] = useState([])
  const [editId, setEditId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterLocationData, setFilterLocationData] = useState({});

  const rowStyle = (row) => {
    const po_condition = row?.po_type === 'Reclamation PO'
    const backgroundColor = po_condition && '#B9D9EB';
    const color = po_condition && 'black';
    return { backgroundColor, color };
  };

  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  if(ModalformValues){
    const formElementsArray = [];
    for (let key in ModalformValues) {
      formElementsArray.push({
        id: key,
        config: ModalformValues[key]
      });
    }
  }
  
  const inputChangedHandler = (event, inputIdentifier) => {
    try{
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }


function serachFliterBoxData(data){
 try{
  let searchFormData = {}

  if(data){
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType ===  globaldata.multiSelect) {
          let multiselectData =   data[formElementIdentifier].value?.map((fValue, indexId)=> {
            return   fValue.value;
            });
            searchFormData[formElementIdentifier] = multiselectData;
        }
        else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
          if(formElementIdentifier === "clientId"){
            searchFormData[formElementIdentifier] = data[formElementIdentifier].value.value;
          }
          else if((data[formElementIdentifier].value)) {
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value.label;
          }
        }
        else{
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
        }
      }
  }
  
  return searchFormData;
 } catch (e) {
   setHasError({
     error: true,
     message: e
   })
 }
}


const conditionalBasedInputValue = (formValues) => {
  let keyValueArray = Object.entries(formValues);
  let checkboxFormValues = [];
  let inputFormValues = [];

  keyValueArray.forEach(([key, value]) => {
    if (value.elementType === 'checkbox') {
      checkboxFormValues.push([key, value]);
    } else {
      inputFormValues.push([key, value]);
    }
  });

  if (pageLayoutData[1]?.title1 === 'Location' && userRole_name) {
    keyValueArray.splice(keyValueArray.length - 1, 0, ['whitelist_check', checkBoxObj.whitelist_check]);

    const formValuesArray = [...keyValueArray, ...checkboxFormValues];
    let updatedObject = Object.fromEntries(formValuesArray);
    setModalformValues(updatedObject);
  } else {
    const formValuesArray = [...inputFormValues, ...checkboxFormValues];
    let updatedFormValues = Object.fromEntries(formValuesArray);
    delete updatedFormValues['whitelist_ip'];
    setModalformValues(updatedFormValues);
  }
};



  async function instantValuesUpdateFilterBox() {
    try{
    let url = pageLayoutData[0].filterEndPoint + `?${globaldata.customerId}=` + cookies.get(globaldata.customerId) + `&${globaldata.userId}=` + cookies.get(globaldata.userId) + `&${globaldata.userLocationId}=` + cookies.get(globaldata.userLocationId) + `&${globaldata.userRoleName}=` + cookies.get(globaldata.userRoleName) + `&${globaldata.language}=` + language + `&${globaldata.startFrom}=` + headerData.start_from
    let getdrpdwnresponse = await FetchAPI(url);
    handleNetworkErrors(getdrpdwnresponse,setHasError);
    const getdrpdwnresponseJson = await getdrpdwnresponse.json();
    const updateForm = {
      ...formValues
    }
    const dropVal = {
      ...getdrpdwnresponseJson.data
    }
    let obj;
    obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
      if (Object.keys(el, updateForm)) {
        if (!isEmpty(dropVal[el])) {
          if (updateForm[el].elementType == globaldata.select) {
            updateForm[el].elementConfig.options = dropVal[el];
            updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
          }
          else if (updateForm[el].elementType ==  globaldata.multiSelect) {
            updateForm[el].elementConfig.options = dropVal[el];
          }
        }
        else {
          if (updateForm[el].elementType == globaldata.select)
            updateForm[el].elementConfig.options = initialValue;
          if (updateForm[el].elementType ==  globaldata.multiSelect)
            updateForm[el].elementConfig.options = null;
          //updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
        }
      }
      setformValues(updateForm);
    })
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleTakeAction = (value,status,type) => {
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].actionButtonItems.className);
    setModalformValues(pageLayoutData[0].actionButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].actionButtonItems.saveEndpoint)
    setshowModal(true);
    setIsApproved(status);
    setCommonTitle(pageLayoutData[1].title1);
    setmodalType(type === "approve" ? "Approve Comment(s)" : "Reject Comment(s)");
    if(type === "reject"){
      pageLayoutData[0].actionButtonItems.formValues.has_comment.validate.required = true
      setModalformValues(pageLayoutData[0].actionButtonItems.formValues)
    }
    setextraId(value.id);
  }

  async function searchTableData(data) {
    try{
    setIsLoading(true);
    setloadTableData(false);
    let title1 = pageLayoutData[1].title1
    let startFrom = 0;
    let cpage = 0
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(title1 !== globaldata.location && pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}

    let fmData = serachFliterBoxData(data);
    // if(page == 1) {
      //   let startFrom = 0;
      totalParams.start_from = startFrom;
      // }else {
        //   cpage = page -1;
        //   startFrom = cpage * sizePerPage;
        //   totalParams.start_from = startFrom;
        // }
        let newObj = { ...searchFormData, ...totalParams,...fmData}

    setFilterLocationData(fmData)

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined );
      else
      getURL = getURL + `&${globaldata.element}=` + searchInputValue;
      setIsFilterLoader(true)
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        let newArray = []
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson.data.data[i]?.childData?.length === 0) {
            newArray.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(newArray)
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        setpage(1);
        setSelectedValue(1);
        setPageStartFrom(1)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setIsFilterLoader(false)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }  
    }
    else {
     // let newestObj = {...newObj, index:page}
     let newestObj;
     if(!setsearchInputValue || searchInputValue === undefined )
     newestObj = {...newObj}
     else
     newestObj = {...newObj, element:searchInputValue}
     setSelectedValue(1);
     setPageStartFrom(1);
     setIsFilterLoader(true)
      let responseData = await PostAPI(getURL, newestObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        let newArray = [...array]
        let expandArray = []
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expandArray.push(responseDataJson.data.data[i].name)
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)  
        setArray(newArray)
        setExpand(expandArray)
        setResponse(responseDataJson.data.data)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        setpage(1);
        setSelectedValue(1);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setIsFilterLoader(false)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
    setIsLoading(false);
  }

  async function handleTpPdfDownload(value) {
    try{
    setshowExpandColumn(false)
    setIsLoader(true);
    FetchAPI(
      `${pageLayoutData[1].subComponentsItems.tpReportPdfEndpoint}?delivery_id=${value.id}&customer_id=${cookies.get("customer_id")}&user_id=${cookies.get("user_id")}&tp_id=${value.tp_id}`
    )
    .then(responseJson => responseJson.json())
    .then((response) => {
      setIsLoader(false);
     const url = response.data.data
            const link = document.createElement('a');
            link.target = '_self';
            link.href = url;
            link.setAttribute(globaldata.download, url);
            link.click();
})
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  async function exportPdf(e, id) {
    try{
    setshowExpandColumn(false)
    setIsLoader(true);
    e.preventDefault();
    FetchAPI(
      `${pageLayoutData[0].exportEndPoint}?${globaldata.deliveryId}=${id}&${globaldata.customerId}=${cookies.get(globaldata.customerId)}&${globaldata.userId}=${cookies.get(globaldata.userId)}`
    )
    .then(responseJson => responseJson.json())
    .then((response) => {
      setIsLoader(false);
     const url = response.data.data
            const link = document.createElement('a');
            link.target = '_self';
            link.href = url;
            link.setAttribute(globaldata.download, url);
            link.click();
})
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const deliveryFifoFunc = async(id) => {
    try{
    const payloadObj = {
      id: id,
      user_id: cookies.get(globaldata.userId)
    }
    const getURL = pageLayoutData[0].refreshEndPoint;
    setIsLoader(true)
    const response = await PostAPI(getURL,payloadObj)
    handleNetworkErrors(response,setHasError);
    if(response.status == 200) {
      setIsLoader(false)
      setDisableRefreshIcon(false)
      if(response.data.data.status == 1){
        swal({text:`${t(`${response.data.data.message}`)}`, icon: globaldata.success, button:`${t("alerts.ok")}`}) 
        getLatestTableData()
      }else{
        swal({
        icon: globaldata.warning,
        text:`${t(`${response.data.data.message}`)}`,
        buttons: `${t('alerts.ok')}`,
         dangerMode: true,
        })
      }
    }else {
      swal({title:`${t("alert.wrong")}`,
        icon: globaldata.warning,
        buttons: `${t('alerts.ok')}`,
         dangerMode: true,
        })
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const handleRefreshIcon = (id) => {
    try {
      setshowExpandColumn(false)
      setDisableRefreshIcon(true)
      setFifoId(id)
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  useEffect(() => {
    if(pagination.pageIndex){
      handleLatestTableData(pagination.pageIndex)
    }
    else if(pagination.pageIndex === 0 && isPageChanged){
      handleLatestTableData(pagination.pageIndex)
    }
  },[pagination])

  useEffect(() => {
    if(fifoId != undefined && disableRefreshIcon){
      deliveryFifoFunc(fifoId)
    }
  },[fifoId,disableRefreshIcon])

  async function filteredExport2(data) {
    setValues(data)
  }

  async function clearTableData(event) {
    try{
    setloadTableData(false);
    setshowFilter(!showFilter);
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined );
      else
      getURL = getURL + `&${globaldata.element}=` + searchInputValue;
      setIsLoading(true);
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        let newArray = []
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson.data.data[i]?.childData?.length === 0) {
            newArray.push(responseDataJson.data.data[i].name)
          }
        }
        setArray(newArray)
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        setpage(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIsLoading(false)
        setloadTableData(true);
        setValues();
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setIsLoading(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }  
    }
    else {
     // let newestObj = {...newObj, index:page}
     let newestObj;
     if(!setsearchInputValue || searchInputValue === undefined )
     newestObj = {...totalParams}
     else
     newestObj = {...totalParams, element:searchInputValue}
     setSelectedValue(1);
     setPageStartFrom(1);
     setIsLoading(true);
      let responseData = await PostAPI(getURL, newestObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let newArray = [...array]
        let expandArray = []
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expandArray.push(responseDataJson.data.data[i].name)
        }
        setArray(newArray)
        setExpand(expandArray)
        setResponse(responseDataJson.data.data)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        setpage(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIsLoading(false);
        setloadTableData(true);
        setValues();
        setformValues(pageLayoutData[0].formValues);
      }
      else {
        setloadTableData(false);
        setIsLoading(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  // async function clearSearchData(event) {
  //   setloadTableData(false);
  //   const getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
  //   const productDataValues = await FetchAPI(getURL);
  //   const productDataValuesJson = await productDataValues.json();
  //   for (let [key, value] of Object.entries(productDataValuesJson.data.data)) {
  //     value.actions = <div> {(value.add ==  true) && <a onClick={ (e) => opneParent(e, value) }><i className="fa fa-plus-square-o fa-add"></i></a>}  { (value.edit ==  true) && <a onClick={ (e) => editOpenModal(e, value) }><i className="fa fa-pencil-square-o fa-edit"></i></a>} {  (value.del ==  true) && <a onClick={ (e) => deleteOpenModal(e, value) }><i className="fa fa-trash-o fa-delete"></i></a>}</div>;
  //   }
  //   setproductsData(productDataValuesJson.data.data);
  //   settotalrecords(productDataValuesJson.data.recordsTotal);
  //   setformValues(pageLayoutData[0].formValues);
  //   setsearchInputVlaue();
  //   setshowCSearch(false);
  //   setloadTableData(true);
  // }

  async function getLatestTableData() {
    try{
    setformValues(pageLayoutData[0].formValues);
    setChangeTreeValue(false);
    if(pageLayoutData[0].filterStatusDefault === true)
    setshowFilter(true);
    else
    setshowFilter(false);
    setloadTableData(false);
    setsearchInputValue('');
    setshowCSearch(false);
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + `&${globaldata.index}=` + page;
      // if(!setsearchInputValue || searchInputValue === undefined || searchInputValue !== '' )
      // getURL = getURL;
      // else
      // getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        let newArray = [];
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson.data.data[i]?.childData?.length === 0) {
            newArray.push(responseDataJson.data.data[i].name)
          }
        }
        setArray(newArray)
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setPageStartFrom(1);
        setPagination((prev) => ({
        ...prev,
        pageIndex: 0,
      }));
        setpage(1);
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }  
    }
    else {
      let newObj = {...totalParams, index:page}
      // let newestObj;
      // if(!setsearchInputValue || searchInputValue === undefined )
      // newestObj = {...newObj}
      // else
      // newestObj = {...newObj, element:searchInputValue}
    //  let newestObj = {...totalParams, index:page}
      let responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        let expandArray = []
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expandArray.push(responseDataJson.data.data[i].name);
        }
        setExpand(expandArray)
        setResponse(responseDataJson.data.data)
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setPagination((prev) => ({
          ...prev,
          pageIndex: 0,
        }));
        setpage(1);
        setColumns(responseDataJson.data.columns);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }
    }
    setloadTableData(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  // const MySearch = (props) => {
  //   let input;
  //   const handleClick = async () => {
  //     if(input.value == ''){
  //       return false;
  //     }
  //     let getURL;
  //     setloadTableData(false);
  //     props.onSearch(input.value);
  //     setsearchInputVlaue(input.value);
  //     if(pageLayoutData[1].title1 === 'Sales Delivery Details')
  //     getURL = pageLayoutData[1].subComponentsItems.apiEndPoint+ '&user_id=' +cookies.get('user_id');
  //     else
  //     getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
  //     const productDataValues = await FetchAPI(getURL);
  //     const productDataValuesJson = await productDataValues.json();
  //     for (let [key, value] of Object.entries(productDataValuesJson.data.data)) {
  //       value.actions = <div> {(value.add ==  true) && <a onClick={ (e) => opneParent(e, value) }><i className="fa fa-plus-square-o fa-add"></i></a>}  { (value.edit ==  true) && <a onClick={ (e) => editOpenModal(e, value) }><i className="fa fa-pencil-square-o fa-edit"></i></a>} {  (value.del ==  true) && <a onClick={ (e) => deleteOpenModal(e, value) }><i className="fa fa-trash-o fa-delete"></i></a>}</div>;
  //     }
  //     setColumns(productDataValuesJson.columns);
  //     setproductsData(productDataValuesJson.data.data);
  //     setformValues(pageLayoutData[0].formValues);
  //     settotalrecords(productDataValuesJson.data.recordsTotal);
  //     setshowCSearch(true);
  //     setloadTableData(true);
  //   };
  //   return (
  //     <div>
  //       <MDBCol md="4" className="mb-4">
  //       <input
  //         className="form-control"
  //         style={{ backgroundColor: 'white' }}
  //         placeholder="Search"
  //         ref={n => input = n}
  //         type="text"
  //         value={searchInputVlaue}
  //       />
  //     </MDBCol>
  //     <MDBCol md="2" className="mb-2">
  //       {(showCSearch == false) && <ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName="Search" /> }
  //       {(showCSearch == true) && <ButtonField color="info" key="ModalCLRBTN" submit={ (e) => clearSearchData(e) } BName="Clear" />} 
  //     </MDBCol>
  //     {/* <MDBCol md="1" className="mb-1">
  //     </MDBCol> */}
  //     </div>
  //   );
  // };

  const handleTableChange = (event, { page, sizePerPage }) => {
  try{
    if (event == 'inputTypes.search') {
      return;
    }
    const currentIndex = (page - 1) * sizePerPage;
    setpage(page);
    setsizePerPage(sizePerPage);
    handlePageChange(page);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  async function handleLatestTableData(page) {
    try{
    setloadTableData(false);
    setIsPageChanged(true);
    setIsLoading(true);
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    let fmData = serachFliterBoxData(values);
    if(page == 0) {
      totalParams.start_from = 0;
    }else {
      totalParams.start_from = pagination.pageSize * pagination.pageIndex;
    }
    let newObj = { ...fmData, ...totalParams, ...filterLocationData}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL + `&${globaldata.index}=` + page;
      else
      getURL = getURL + `&${globaldata.element}=` + searchInputValue+`&${globaldata.index}=` + page;
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        let newArray = []
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            newArray.push(responseDataJson.data.data[i].name);
          }
        }
        setArray([...new Set(newArray)])
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }  
    }
    else {
      let newestObjSearch;
      let newestObj = {...newObj, index:page}
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObjSearch = {...newestObj}
      else
      newestObjSearch = {...newestObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObjSearch);
      handleNetworkErrors(responseData,setHasError);
      let responseDataJson = responseData.data;
      let expandArray = []
      for (let i = 0; i < responseDataJson.data.data.length; i++) {
        expandArray.push(responseDataJson.data.data[i].name);
      }
      setExpand(expandArray)
      setResponse(responseDataJson.data.data)
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(pageLayoutData[0].addButtonType =='buildmodal'){
          buildActions(responseDataJson.data)
        }else if(!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data)
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('alert.wrong');
      }
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
    setIsLoading(false)
}


  const handleGlobalSearch = async (input) => {
    setsearchInputValue(input)
    setIsLoading(true);
    setloadTableData(false);
    let totalParams;
    let startFrom = 0;
    let searchFormData = {};
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = { ...totalParams, ...extraParameteres }
    }
    totalParams = { ...totalParams, start_from: startFrom, ...dynamicParameters }
    for (let formElementIdentifier in formValues) {
      searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
    }
    totalParams = { ...totalParams, element: input.replace(/^\s+|\s+$/gm, '') }
    let newObj = { ...searchFormData, ...totalParams }
    if (pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      let responseData = await FetchAPI(getURL);
      if (responseData.status == 200) {
        setError(false);
        let responseDataJson = await responseData.json();
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
        if (!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data);
        }
        setpage(1);
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns, responseDataJson.data.data, setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setformValues(pageLayoutData[0].formValues);
        settotalrecords(responseDataJson.data.recordsTotal);
        setshowCSearch(true);
        setloadTableData(true);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    else {
      let responseData = await PostAPI(getURL, newObj);
      let responseDataJson = responseData.data;
      for (let i = 0; i < responseDataJson.data.data.length; i++) {
        expand.push(responseDataJson.data.data[i].name);
      }
      setExpand(expand)
      setResponse(responseDataJson.data.data)
      if (responseData.status == 200) {
        setError(false);
        let responseDataJson = responseData.data;
        if (!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data);
        }
        setpage(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns, responseDataJson.data.data, setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setformValues(pageLayoutData[0].formValues);
        settotalrecords(responseDataJson.data.recordsTotal);
        setshowCSearch(true);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setIsLoading(false);
  }

  async function handleClearSearch() {
    setIsLoading(true);
    setloadTableData(false);
    let totalParams;
    let startFrom = 0;
    let cpage;
    let searchFormData = {};
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = { ...totalParams, ...extraParameteres }
    }
    totalParams = { ...totalParams, start_from: startFrom }
    for (let formElementIdentifier in values) {
      searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
    }
    totalParams = { ...totalParams, ...dynamicParameters, ...searchFormData }
    if (pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      setsearchInputValue();
      let responseData = await FetchAPI(getURL);
      if (responseData.status == 200) {
        setError(false);
        let responseDataJson = await responseData.json();
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
        if (!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data);
        }
        setpage(1);
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns, responseDataJson.data.data, setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setformValues(pageLayoutData[0].formValues);
        settotalrecords(responseDataJson.data.recordsTotal);
        setsearchInputValue();
        setshowCSearch(false);
        setloadTableData(true);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    else {
      setsearchInputValue();
      let responseData = await PostAPI(getURL, totalParams);
      if (responseData.status == 200) {
        setError(false);
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expand.push(responseDataJson.data.data[i].name);
        }
        setExpand(expand)
        setResponse(responseDataJson.data.data)
        if (!isEmpty(responseDataJson.data.data)) {
          featureActions(responseDataJson.data);
        }
        setpage(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns, responseDataJson.data.data, setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setformValues(pageLayoutData[0].formValues);
        settotalrecords(responseDataJson.data.recordsTotal);
        setsearchInputValue();
        setshowCSearch(false);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setIsLoading(false);
  };

  const open = () => {
    try{
      setmodalType(`${t(globaldata.add)}`);
      setModalTitle(pageLayoutData[0].addButtonName);
      setModalformValues(pageLayoutData[0].addButtonItems.formValues)
      setSaveUrl(pageLayoutData[0].addButtonItems.saveEndPoint)
      setCommonTitle(pageLayoutData[0].addButtonName)
      // i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonNameEn) : setCommonTitle(pageLayoutData[0].addButtonName)
      setModalWidth(pageLayoutData[0].addButtonName === 'Transaction Groups' ? 'modal-70w' : 'modal-55w') // setModalWidth(pageLayoutData[0].addButtonItems.className);
    // setDropDownApi(pageLayoutData[0].addButtonItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
      setDropDownApi(pageLayoutData[0].addButtonItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ?
      pageLayoutData[0].addButtonItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language: globaldata.notFound);
      setuniqueid();
      setIsDragAndDrop(pageLayoutData[0]?.addButtonItems?.isDragAndDrop)
      // setextraId();
      setshowModal(true);
      (pageLayoutData[0].addButtonItems.hasOwnProperty(globaldata.table) ? 
        setTable(pageLayoutData[0].addButtonItems.Table) : 
        setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty(globaldata.headers) ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const openChild = () => {
    try{
     setextraId();
    setuniqueid();
    setmodalType(`${t(globaldata.add)}`);
    setCommonTitle(pageLayoutData[0].addButtonChildName)
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonChildItems.className);
    setModalTitle(pageLayoutData[0].addButtonChildName);
    setModalformValues(pageLayoutData[0].addButtonChildItems.formValues)
    setCommonTitle(pageLayoutData[0].addButtonChildName)
    setSaveUrl(pageLayoutData[0].addButtonChildItems.childEndPoint)
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonChildItems.className);
    pageLayoutData[0].addButtonChildName === 'Reclamation' ? setDropDownApi(pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&location_id=`+ cookies.get(globaldata.userLocationId)+`&${globaldata.language}=`+language) : 
    setDropDownApi(pageLayoutData[0].addButtonChildItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ?
    pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language: globaldata.notFound);
    //setDropDownApi(pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    setshowModal(true);
    if(pageLayoutData[0].addButtonChildName === 'Reclamation Delivery' || pageLayoutData[0].addButtonChildName === "AttributeSet"){
    (pageLayoutData[0].addButtonChildItems.hasOwnProperty(globaldata.table) ? 
    setTable(pageLayoutData[0].addButtonChildItems.Table) : 
    setTable(false));
    (pageLayoutData[0].addButtonChildItems.hasOwnProperty(globaldata.headers) ? 
      setHeaders(pageLayoutData[0].addButtonChildItems.headers) : 
      setHeaders(null));
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const openComponent =async (event, value) => {
    try{
    setIsLoader(true);
    setModalformValues(pageLayoutData[0].addButtonItems)
   // setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    let editURL = '';
      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+
      `?${globaldata.customerId}=`+cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+cookies.get(globaldata.userId)+`&${globaldata.language}=`+language;
     // setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')  : 'not found' );
    // }
    //pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? dropDownApi : 'not found' 
     const productDetailsJson = await getWizardDataService(editURL);
      setIsLoader(false);
      setWizardData({
        productsDetail: productDetailsJson
      })
    setmodalType(`${t("edit")}`);
    setmodalgetURL(editURL)
  //  setuniqueId(value.id);
 //   (value.image) ? setImagePath(value.image) : setImagePath()
 
    setRenderComponent(true);
    setShowParentContent(false);
    // if(pageLayoutData[1].title1 === 'Role'){
    //   uniqueId = value.role_id;
    //   setmodalgetURL('https://staging.esealcom.com:3003/role-management/get-inheritroledetails?role_id=' + uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id'));
    // }
    // else if(pageLayoutData[1].title1 === 'Products'){
    //   uniqueId = value.product_id;
    //  let editURL = pageLayoutData[1].subComponentsItems.editEndPoint + '?product_id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //  setmodalgetURL(editURL);
    //  setProductId(uniqueId);
    // }
    // else
    // {
    //   uniqueId = value.productName;
    //   let editURL = pageLayoutData[1].subComponentsItems.editEndPoint;
    //   //let editURL = pageLayoutData[1].subComponentsItems.editEndPoint+ '?productName=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //   setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id'));
    //   setmodalgetURL(editURL);
    // }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const openComponent1 = async() => {
    try{
    setIsLoader(true)
    setmodalType(`${t('add')}`);
    //{backCheck === true ? setModalformValues(pageLayoutData[0].backButtonItems):setModalformValues(pageLayoutData[0].addButtonItems)}
   // setModalformValues(pageLayoutData[0].addButtonItems)
    setModalformValues(pageLayoutData[0].addButton3Items)
    setRenderComponent(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language);
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language  : globaldata.notFound
    const productsViewJson = await getWizardDataService(productViewEndpoint)
    setIsLoader(false)
    setWizardData({
      productsView: productsViewJson,
    })   
    // if(pageLayoutData[1].title1 === 'Role'){
    //   setDropDownApi();  
    // }
    // if(pageLayoutData[1].title1 === 'Company'){
    //   setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    // }
    // if(pageLayoutData[1].title1 === 'Products'){
    //   setDropDownApi(pageLayoutData[0].filterEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    // }
    setShowParentContent(!showParentContent);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
  const opneParent = (event, data) => {
    let inputValues = pageLayoutData[0].addButtonParentItems.formValues
    try{
    setVal1(data.hierarchy_name)
    setVal2();
    setWareId(data.ware_id)
    setmodalType(`${t(globaldata.add)}`);
    setModalTitle(pageLayoutData[0].addButtonParentName);
    // i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonParentNameEn) : setCommonTitle(pageLayoutData[0].addButtonParentName)
    setCommonTitle(pageLayoutData[0].addButtonParentName)
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonParentItems.className);
    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
    // (pageLayoutData[0].editButtonParentItems !== undefined ? 
    //   setSaveUrl(pageLayoutData[0].editButtonParentItems.addParentEndPoint) : 
    //   setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint));
    setuniqueid(data.name);
    setextraId(data.po_type);
//  }
 // setextraId(data.name); } 
  // else
  // else
  //   setextraId(data.name);
    //setextraId(event.name);
   // setuniqueid(data.name);
   // setextraId(data.name)
     if (data.po_type === "Reclamation PO") {
      const materialAgainstLocationApi = pageLayoutData[0].addButtonChildItems.formValues['from_location'].update.endPoint
      setDropDownApi(materialAgainstLocationApi+
        `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&location_id=`+ cookies.get(globaldata.userLocationId) +`&${globaldata.poNumber}=`+ data.delivery_id);
    }else{
      setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+
        `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.poNumber}=`+ data.delivery_id);
    }
    setshowModal(true);
    (pageLayoutData[1].title1 === 'Location' ? conditionalBasedInputValue(inputValues) : setModalformValues(inputValues))
  
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const addChild = (event, data) => {
    try{
    //updateTreeData();
    const inputValues = pageLayoutData[0].addButtonParentItems.formValues;
    let c =
    /* To Render vaue Dynamically in Location Types Feature in Company Module*/
    // data.node.module_id ? setVal1(data.node.module_id)
    // : data.node.l_location_type_id ? setVal1(data.node.l_location_type_id)
    // : setVal1(data.node.c_parent_id)
    // data.node.module_id ? setVal1(data.node.module_id) : setVal1(data.node.l_location_type_id)
    /* To Render vaue Dynamically in Location Types Feature in Company Module*/
    setVal1(data.hierarchy_name)
    setVal2(data.name)
    setuniqueid(data.name);
    setWareId(data.ware_id)
    setextraId();
    setmodalType(`${t(globaldata.add)}`);
    setModalTitle(pageLayoutData[0].addButtonParentName);
    setCommonTitle(pageLayoutData[0].addButtonParentName)
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonParentItems.className);
    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
    //setuniqueid(data.name);
    // if(pageLayoutData[1].title1 === 'Sales Delivery Details' ||
    // pageLayoutData[1].title1 === 'Location Types')
    // {
    //   setDeliveryId(data.name);
    //   setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id'));
    // }  
   // else
      setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+'&location_id='+ cookies.get(globaldata.userLocationId)+`&${globaldata.language}=`+language);
      setshowModal(true);
      (pageLayoutData[1].title1 === 'Location' ? conditionalBasedInputValue(inputValues) : setModalformValues(inputValues))
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const restoreParent = (event, data) => {
    try{
    setshowExpandColumn(false)
   // const restoreURL = pageLayoutData[0].addButtonChildItems.restoreChildEndPoint+'?location_type_id='+data.name;
    const restoreURL = pageLayoutData[0].addButtonChildItems.restoreChildEndPoint+`?${globaldata.id}=`+data.name+`&${globaldata.language}=`+language;
    swal({title:`${t("alerts.sure")}`,
         text:`${t("alerts.restored_data")}`,
        icon: globaldata.warning,
        buttons: [`${t('alerts.cancel')}`,
        `${t('alerts.ok')}`],
         dangerMode: true,
        })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(restoreURL)
        swal(`${t('alerts.data_restored')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.restored_failed')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const restoreChild = (event, data) => {
    try{
  //  const restoreURL = pageLayoutData[0].addButtonParentItems.restoreParentEndPoint+'?location_id='+data.node.name;
    const restoreURL = pageLayoutData[0].addButtonParentItems.restoreParentEndPoint+`?${globaldata.id}=`+data.name+`&${globaldata.language}=`+language;
    //
 swal({title:`${t("alerts.sure")}`,
         text:`${t("alerts.restored_data")}`,
        icon: globaldata.warning,
        buttons: [`${t('alerts.cancel')}`,
        `${t('alerts.ok')}`],
         dangerMode: true,
        })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(restoreURL)
        swal(`${t('alerts.data_restored')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.restored_failed')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const searchableChild = (event, data) => {
    try{
    const flag = (data.search == false) ? 1 : 0;
    const customTitle = (flag == 1) ? `${t('alerts.searchable')}` :
    `${t('alerts.unsearchable')}`;

   // const flag = 0;
  //  const restoreURL = pageLayoutData[0].addButtonParentItems.restoreParentEndPoint+'?location_id='+data.node.name;
    const searchableURL = pageLayoutData[0].addButtonParentItems.searchParentEndPoint+
    `?${globaldata.id}=`+data.name+`&${globaldata.extraId}=`+event.name+`&${globaldata.flag}=`+flag;
    //
    swal({
      title: customTitle,
      text: `${t('alerts.beware_of_doing')}`,
      icon:  globaldata.warning,
      buttons: [`${t('alerts.cancel')}`,
      `${t('alerts.ok')}`],
      //dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(searchableURL);
        swal(`${t('alerts.update_successfully')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const deleteParent = (event, id) => {
    try{
    setshowExpandColumn(false)
    let delURL;
    let URL;
    if(cookies.get("customer_id") === "15" && pageLayoutData[1].title1 === "Delivery"){
      URL = pageLayoutData[1].subComponentsItems.deleteMasterDelivery;
    }else{
      URL = (pageLayoutData[0].addButtonChildItems) ? pageLayoutData[0].addButtonChildItems.deleteChildEndPoint : pageLayoutData[0].addButtonItems.deleteChildEndPoint
    }
      delURL = URL +'?id='+id.name+ '&customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language
        swal({title:`${t("alerts.sure")}`,
         text:`${t("alerts.deleted_not_recovered")}`,
        icon: globaldata.warning,
        buttons: [`${t('alerts.cancel')}`,
        `${t('alerts.ok')}`],
         dangerMode: true,
        })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal(`${t('alerts.data_deleted')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}


  const deleteChildPassword = (event, id) => {
    try{
    let delURL = pageLayoutData[0].deletePwdButtonItems.deleteEndPoint + '?id=' + id.name + '&customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
    switch (id.is_mapped) {
      case 1:
        swal({
          title: id.alert,
          text: "Do you want to un-map and delete?",
          icon: "info",
          buttons: [`${t('alerts.cancel')}`,
          `${t('alerts.ok')}`],
          dangerMode: true,
        })
          .then((willDelete) => {
            if (willDelete) {
              setmodalType(`${t('enter')}`);
              setuniqueid(id.name);
              setModalTitle('Password');
              setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
              setSaveUrl(delURL);
              setModalWidth('modal-50w');
              setshowModal(true);
              // swal("Poof! Your data has been deleted!", {
              //   icon: "success",
              //   timer: 2000,
              //   button: false
              // });
              // setTimeout(() => {
              //   getLatestTableData();
              // }, 1000);
            } else {
              swal(t("Your data is safe!"), {
                timer: 2000,
                button: false
              });
            }
          });
        break;
      default:
        (async function del1() {
          swal({
            title: t("Are you sure?"),
            text: t("Once deleted, you will not be able to recover this data!"),
            icon: t("warning"),
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then((willDelete) => {
              if (willDelete) {
                setmodalType(`${t('enter')}`);
                setuniqueid(id.name);
                setModalTitle('Password');
                setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
                setSaveUrl(delURL);
                setModalWidth('modal-50w');
                setshowModal(true);
                // swal("Poof! Your data has been deleted!", {
                //   icon: "success",
                //   timer: 2000,
                //   button: false
                // });
                // setTimeout(() => {
                //   getLatestTableData();
                // }, 1000);
              } else {
                swal(t("Your data is safe!"), {
                  timer: 2000,
                  button: false
                });
              }
            });
        })();
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const deleteParentPassword = (event, id) => {
    try{
    let delURL = pageLayoutData[0].deletePwdButtonItems.deleteParentEndPoint + '?id=' + id.name + '&extra_id=' + event.name + '&language=' + language;
    switch (id.is_mapped) {
      case 1:
        swal({
          title: id.alert,
          text: "Do you want to un-map and delete?",
          icon: "info",
          buttons: [`${t('alerts.cancel')}`,
          `${t('alerts.ok')}`],
          dangerMode: true,
        })
          .then((willDelete) => {
            if (willDelete) {
              setmodalType(`${t('enter')}`);
              setuniqueid(id.name);
              setModalTitle('Password');
              setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
              setSaveUrl(delURL);
              setModalWidth('modal-50w');
              setshowModal(true);
              // swal("Poof! Your data has been deleted!", {
              //   icon: "success",
              //   timer: 2000,
              //   button: false
              // });
              // setTimeout(() => {
              //   getLatestTableData();
              // }, 1000);
            } else {
              swal(t("Your data is safe!"), {
                timer: 2000,
                button: false
              });
            }
          });
        break
      default:
        (async function del1() {
          swal({
            title: `${t("alerts.sure")}`,
            text: `${t("alerts.deleted_not_recovered")}`,
            icon: "warning",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then((willDelete) => {
              if (willDelete) {
                setmodalType(`${t('enter')}`);
                setuniqueid(id.name);
                setModalTitle('Password');
                setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
                setSaveUrl(delURL);
                setModalWidth('modal-50w');
                setshowModal(true);
                // swal("Poof! Your data has been deleted!", {
                //   icon: "success",
                //   timer: 2000,
                //   button: false
                // });
                // setTimeout(() => {
                //   getLatestTableData();
                // }, 1000);
              } else {
                swal(t("Your data is safe!"), {
                  timer: 2000,
                  button: false
                });
              }
            });
        })()
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const openModalTreeView = (event, data) => {
    try{
    setmodalType(t('view'));
    setModalTitle( t(pageLayoutData[1].title1));
    // if(pageLayoutData[1].title1 === 'Sales Delivery Details' ||
    // (pageLayoutData[1].title1 === 'Products' && pageLayoutData[1].title2 === 'Components')
    // || pageLayoutData[1].title1 === 'Location Types')
    //   setmodalgetURL(pageLayoutData[0].treeEndPoint+`?${globaldata.id}=`+data.name);
    // else
    setmodalgetURL(pageLayoutData[0].treeEndPoint+'?id='+data.name+'&customer_id='+ cookies.get('customer_id')+'&language='+language);
    setShowModald3(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const openLocation = () => {
    try{
    setModalTitle(pageLayoutData[0].addButtonName4);
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButton4Items.className);
    setModalformValues(pageLayoutData[0].addButton4Items.formValues)
    setSaveUrl(pageLayoutData[0].addButton4Items.apiEndPointLocation)
    setmodalType(`${t(globaldata.add)}`);
    setDropDownApi(pageLayoutData[1].subComponentsItems.getLocationDropdowns + `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+cookies.get(globaldata.userId)+`&${globaldata.language}=`+language); 
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const openBusinessUnit = () => {
    try{
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName2);
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonItems2.className);
    setModalformValues(pageLayoutData[0].addButtonItems2.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems2.apiEndPointBussinessUnit)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.getBusinessDropdowns) ? dropDownApi : globaldata.notFound)
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  

  const opneEditParent = (row,rowInfo) => {
    try{
    let inputValues =  pageLayoutData[0].editButtonParentItems !== undefined ? 
    pageLayoutData[0].editButtonParentItems.formValues : pageLayoutData[0].addButtonParentItems.formValues
    let c =
    setLine(rowInfo.line)
    setVal1(rowInfo.hierarchy_name)
    setVal2(rowInfo.parentid)
    setmodalType(`${t("edit")}`);
    // i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonParentNameEn) : setCommonTitle(pageLayoutData[0].addButtonParentName)
    setCommonTitle(pageLayoutData[0].addButtonParentName)
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonParentItems.className);

    let title1 =  pageLayoutData[1].title1
    let title2 =  pageLayoutData[1].title2
    setModalTitle(pageLayoutData[0].addButtonParentName);
   // setModalformValues(pageLayoutData[0].addButtonParentItems.formValues);

    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
    // if(pageLayoutData[1].title1 === 'Sales Delivery Details')
    // {
    //   setProductId(rowInfo.node.product_id);
    //   setDeliveryId(rowInfo.node.id)
    //   setmodalgetURL(pageLayoutData[0].getParentEndPoint+
    //     '?product_id='+rowInfo.node.product_id+'&delivery_id='+rowInfo.node.id);
    // }
    // else if(pageLayoutData[1].title1 === 'Location Types')
    // {
    //   setLocationId(rowInfo.node.name);
    //   setmodalgetURL(pageLayoutData[0].addButtonParentItems.getParentEndPoint+
    //     '?location_id='+rowInfo.node.name);
    // }
    // else
    setuniqueid(rowInfo.name);
    setextraId(row.hasOwnProperty('childData')? row.name : rowInfo.name);
    setmodalgetURL(pageLayoutData[0].editButtonParentItems.getParentEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')
    +'&id='+ rowInfo.name+'&extra_id='+ row.name + '&delivery_id=' + row.delivery_id+'&language='+language);
   // setmodalgetURL(pageLayoutData[0].addButtonParentItems.getParentEndPoint);
    setDropDownApi(pageLayoutData[0].editButtonParentItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language) 
    setshowModal(true);
    (pageLayoutData[1].title1 === 'Location'  ? conditionalBasedInputValue(inputValues): setModalformValues(inputValues));
    
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const close = () => {
    setshowModal(false);
    setShowModald3(false);
  }

  const editOpenModal = (event, id) => {
    try{
    setModalWidth(pageLayoutData[0].addButtonName === 'Transaction Groups' ? 'modal-70w' : 'modal-55w') // setModalWidth(pageLayoutData[0].addButtonItems.className);
    setCommonTitle(pageLayoutData[0].addButtonChildName)
    setmodalType(`${t("edit")}`);
    setModalTitle(pageLayoutData[0].addButtonChildName);
    (pageLayoutData[0].editButtonChildItems.formValues !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonChildItems.formValues) :
       setModalformValues(pageLayoutData[0].addButtonChildItems.formValues));
    //setModalformValues(pageLayoutData[0].addButtonChildItems.formValues);
    // if(pageLayoutData[1].title1 === 'Location Types')
    // {
    //   setLocationTypeId(id.name);
    //   setmodalgetURL(pageLayoutData[0].addButtonChildItems.getChildEndPoint+
    //     '?location_type_id='+id.name);
    // }
    // else
    setuniqueid(id.name)
    const queryParams = {
      id: id.name,
      ...dynamicParameters
    }
    const paramsConverted = new URLSearchParams(queryParams);
    const getURL = (`${pageLayoutData[0].addButtonChildItems.getChildEndPoint}?${paramsConverted.toString()}`);
    setmodalgetURL(getURL);   
     setSaveUrl(pageLayoutData[0].addButtonChildItems.childEndPoint);
     //dropDownApi = {pageLayoutData[0].hasOwnProperty('filterEndPoint') ? pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id') : 'not found' } 
    setDropDownApi(pageLayoutData[0].addButtonChildItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? 
    pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language: 'not found');
    setshowModal(true);
    setIsDragAndDrop(pageLayoutData[0]?.addButtonItems?.isDragAndDrop)
    setTable(pageLayoutData[0].addButtonChildItems.Table);
    setHeaders(pageLayoutData[0].addButtonChildItems.headers)
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
 

  const editOpenModalExtra = (event, id) => {
    const customersArray = ['12','17']
    try{
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0]?.editButtonChildExtraItems?.className)
    setmodalType(`${t("edit")}`);
    setModalTitle(pageLayoutData[0].addButtonChildExtraName);
    customersArray.includes(cookies.get(globaldata.customerId))  ? setTitle1(`${t('Map')}`) : setTitle1('')
    setCommonTitle(pageLayoutData[0].addButtonChildExtraName)
    setModalformValues(pageLayoutData[0].editButtonChildExtraItems.formValues);
    setuniqueid(id.name)
    setmodalgetURL(pageLayoutData[0].editButtonChildExtraItems.getChildEndPoint+`?${globaldata.id}=`+id.name+`&${globaldata.language}=`+language);
    setSaveUrl(pageLayoutData[0].editButtonChildExtraItems.childEndPoint);
    setDropDownApi(pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? 
    pageLayoutData[0].editButtonChildExtraItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language: globaldata.notFound);
    pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty(globaldata.table) ? 
      setTable(pageLayoutData[0].editButtonChildExtraItems.Table) : 
      setTable(false);
    pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty(globaldata.editHeaders) ? 
        setHeaders(pageLayoutData[0].editButtonChildExtraItems.editHeaders) : 
        setHeaders(null);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const editComponent = async(event, value) => {
    try{
    setIsLoader(true);
    (pageLayoutData[0].editButtonItems !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonItems) : 
      setModalformValues(pageLayoutData[0].addButtonItems.formValues));
   // setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
      setshowExpandColumn(false)
    let editURL = '';
      editURL =  pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +value.id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
      setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language  : globaldata.notFound );
      const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.dropdownApiEndPoint) ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + `?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language   : globaldata.notFound;
      const productsViewJson = await getWizardDataService(productViewEndpoint);
      const productDetailsJson = await getWizardDataService(editURL);
      setIsLoader(false);
      setWizardData({
        productsView: productsViewJson,
        productsDetail: productDetailsJson,
      })
    // }
    //pageLayoutData[1].subComponentsItems.hasOwnProperty() ? dropDownApi : 'not found' 
    setmodalType(`${t("edit")}`);
    setmodalgetURL(editURL)
    setuniqueId(value.id);
    (value.image) ? setImagePath(value.image) : setImagePath()
    setRenderComponent(true);
    setShowParentContent(false);
    setIsEditOpen(true)
    // if(pageLayoutData[1].title1 === 'Role'){
    //   uniqueId = value.role_id;
    //   setmodalgetURL('https://staging.esealcom.com:3003/role-management/get-inheritroledetails?role_id=' + uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id'));
    // }
    // else if(pageLayoutData[1].title1 === 'Products'){
    //   uniqueId = value.product_id;
    //  let editURL = pageLayoutData[1].subComponentsItems.editEndPoint + '?product_id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //  setmodalgetURL(editURL);
    //  setProductId(uniqueId);
    // }
    // else
    // {
    //   uniqueId = value.productName;
    //   let editURL = pageLayoutData[1].subComponentsItems.editEndPoint;
    //   //let editURL = pageLayoutData[1].subComponentsItems.editEndPoint+ '?productName=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //   setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id'));
    //   setmodalgetURL(editURL);
    // }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  async function filteredExport(data) {
    try{
    let data1 = data[globaldata.locationType]
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get(globaldata.userId),
      customer_id:cookies.get(globaldata.customerId),
      email:localStorage.getItem(globaldata.email),
      userLocation_id:cookies.get(globaldata.userLocationId),
      userRole_name:cookies.get(globaldata.userRoleName),
      language:language
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null && pageLayoutData[1].title1 !== globaldata.location) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType ===  globaldata.multiSelect) {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else if(data[formElementIdentifier].elementType === globaldata.select){
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
      }
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
      if(data1.value === null){
        swal({title:`${t("alerts.choose_valid_loactionType")}`, text:`${t("alerts.please_cannot_be_selected")}`, icon: globaldata.warning, button:`${t("alerts.ok")}`})
      }
      if(data1.value !== null){
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        responseData = await FetchAPI(getURL);
        handleNetworkErrors(responseData,setHasError);
      }else {
        responseData = await PostAPI(getURL, newObj);
        handleNetworkErrors(responseData,setHasError);
      }
    if(responseData.status == 200){
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:globaldata.success, button:`${t("alerts.ok")}`})
      //window.location.href = "https://tertiary-label-printing.s3.amazonaws.com/OrientReports/2020-10-27/ProductionReport.xlsx";
      }
      else{
        swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon: globaldata.error, button:`${t("alerts.ok")}`})
      }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  async function delelteData(URL) {
    try{
    const getresponse = await FetchAPI(URL);
    handleNetworkErrors(getresponse,setHasError);
    const getresponseJson = await getresponse.json();
    const responseData = getresponseJson.data;
    return responseData;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
  const deleteparent1 = (event, value) => {
    try{
    setshowExpandColumn(false)
    let uniqueId = '';
    let delURL = '';
    // if(pageLayoutData[1].title1 === 'User'){
    //   uniqueId = value.user_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?user_id=' + uniqueId;
    // }else if(pageLayoutData[1].title1 === 'Role'){
    //   uniqueId = value.role_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?role_id=' + uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // }else if(pageLayoutData[1].title1 === 'Company'){
    //   uniqueId = value.customer_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?role_id=' + uniqueId+'&customer_id='+ uniqueId +'&user_id='+cookies.get('user_id');
    // } else if(pageLayoutData[1].title1 === 'Products'){
    //   uniqueId = value.product_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteProductEndPoint + '?product_id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // } else if(pageLayoutData[1].title1 === 'Pallets'){
    //   uniqueId = value.id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + `?${globaldata.id}=` +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // }else if(pageLayoutData[1].title1 === 'Label'){
      uniqueId = value.id;
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
    // }
    let msg = '';
    swal({title:`${t("alerts.sure")}`, text:`${t("alerts.deleted_not_recovered")}`, icon: globaldata.warning,
    buttons: [`${t('alerts.cancel')}`,
     `${t('alerts.ok')}`], 
     dangerMode: true
    }) 
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal(`${t('alerts.data_deleted')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const deleteOpenModal = (event, id,delType) => {
    try{
    setshowExpandColumn(false)
    let delURL;
    if(delType === "child"){
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' + id.id + '&clientId=' + id.clientId + '&locationId=' + id.locationId + '&delType=' + delType + '&customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
    }else if(delType === "parent"){
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint+'?id='+id.name + '&delType=' + delType + '&language='+language;
    }
    else{
      delURL = pageLayoutData[0].addButtonParentItems.deleteParentEndPoint+'?id='+id.name+'&extra_id='+event.name+'&language='+language;
    }
   // delURL = pageLayoutData[0].addButtonParentItems.deleteParentEndPoint+`?${globaldata.id}=`+id.node.name
       // if(pageLayoutData[1].title1 === 'Sales Delivery Details'){
    //   delURL = pageLayoutData[0].addButtonParentItems.deleteParentEndPoint+'?product_id='+id.node.product_id+'&delivery_id='+id.node.id;
    // }
    // if(pageLayoutData[1].title1 === 'Location Types'){
    //   delURL = pageLayoutData[0].addButtonParentItems.deleteParentEndPoint+'?location_id='+id.node.name
    // }
   // setmodalgetURL(pageLayoutData[0].addButtonParentItems.getParentEndPoint+'?product_id='+rowInfo.node.product_id+'&delivery_id='+row.delivery_id);
    swal({title:`${t("alerts.sure")}`,
         text:`${t("alerts.deleted_not_recovered")}`,
        icon: globaldata.warning,
        buttons:  [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
         dangerMode: true,
        })
    .then(async(willDelete) => {
      if (willDelete) {
        await delelteData(delURL);
        getLatestTableData();
        swal(`${t('alerts.data_deleted')}`, {
          icon: globaldata.success,
          timer: 2000,
          button: false
        });
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

const buildModal = () => {
  try{
  setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonItems.className);
  setmodalType('Add');
  setModalformValues(pageLayoutData[0].addButtonItems.formValues);
  setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
  setModalTitle(pageLayoutData[0].addButtonName);
  setSaveUrl(pageLayoutData[1].subComponentsItems.saveApiEndPoint);
  setshowModal(true);
  setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint)
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

async function buildDownload(e, value,hasFile) {
  try{
  setIsLoader(true);
  let fileList = []
  let docList = []
  const paramcomString = new URLSearchParams(dynamicParameters);
  const getURLChild = pageLayoutData[1].subComponentsItems.downloadApiEndPoint + '?id=' + value.id;
  let newgetURL = (`${getURLChild}&${paramcomString.toString()}`);
  const response1 = await FetchAPI(newgetURL);
  handleNetworkErrors(response1,setHasError);
  setIsLoader(false);
  const response1Json = await response1.json();
  let buildurl = response1Json.data['builddetails']
  Object.values(response1Json.data.docdetails).forEach((item => {
    if (item['file'] !== '')
      docList.push(item['file'])
  }))
  if (buildurl['url'] !== null) {
    fileList.push(buildurl['url'])
  }
  function download(fileList) {
      let url = fileList[0];
      let a = document.createElement("a");
      a.setAttribute('href', url);
      a.setAttribute('download', '');
      a.setAttribute('target', '_self');
      a.click();
  }
  if(hasFile && fileList.length !== 0){
    download(fileList)
    return;
  }
  
  if (docList.length !== 0){
    download(docList)
    return;
  }else{
    swal({
      text: "No release notes found for this build",
      icon: "warning",
  });
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const editBuildModal = (event, id, extraId) => {
  try{
  setEditId(id)
  setModalTitle(pageLayoutData[0].addButtonName);
  setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].addButtonItems.className);
  setModalformValues(pageLayoutData[0].editButtonItems.formValues);
  setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
  let editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
    '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    setmodalgetURL(editURL);
   setSaveUrl(pageLayoutData[1].subComponentsItems. updateEndApiPoint);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'));
  // }
  // (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
  setmodalType('Edit');
  setuniqueId(id);
  setextraId(extraId);
  setshowModal(true);
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

// common function for build actions
async function buildActions(data){
  try{
  for (let [key, value] of Object.entries(data.data)) {
    value.action = <div className="action-styles" >
     {value.edit == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true
        ? <a onClick={(e) => editBuildModal(e, value.id)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
     {data.deletePermission == true  || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true 
        ? <a onClick={(e) => deleteOpenModal(e, value, value.delType)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
     {value.download === true ? <a onClick={ (e) => buildDownload(e, value,true) }><i className="fa fa-download-square-o fa-download"></i></a>: ''}
        </div>;  
         }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

async function featureActions(data){
  try{ 
  const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13 || dynamicParameters.customer_id == 17;
  for (let [key, value] of Object.entries(data.data)) {
    /*below condition is for pidilite delivery details */
    if(value.status == "Cancelled"){
      continue;
    }
    value.actions =  <div className="action-styles" >
          {pageLayoutData[0].editParentForm && <a onClick={(e) => opneEditParent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
          {(pageLayoutData[1].title1 !== globaldata.products) && (pageLayoutData[1].title1 !== globaldata.inventory) && (pageLayoutData[1].title1 !== "Transaction" && pageLayoutData[1].title1 !== "Returns") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
          {(value.add == true || value[`${globaldata.add}${pageLayoutData[0].hasOwnProperty(globaldata.addButtonParentName) && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
            }${globaldata.permission}`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
          {(value.edit == true || value[`${globaldata.edit}${pageLayoutData[0].hasOwnProperty(globaldata.addButtonChildName) && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
            }${globaldata.permission}`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
          {(value.del == true || value[`${globaldata.delete}${pageLayoutData[0].hasOwnProperty(globaldata.addButtonChildName) && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
            }${globaldata.permission}`] === true|| value[`${globaldata.delete}${pageLayoutData[0].hasOwnProperty(globaldata.addButtonName) && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
          }${globaldata.permission}`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
          {(value.editExtra == true || value[`${globaldata.edit}${pageLayoutData[0].hasOwnProperty(globaldata.addButtonChildExtraName) && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
            }${globaldata.permission}`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
          {data.editPermission == true || value[`${globaldata.edit}${pageLayoutData[0].hasOwnProperty(globaldata.addButton3Name) && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
            }${globaldata.permission}`] === true
            ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
          {data.deletePermission == true || value[`${globaldata.delete}${pageLayoutData[0].hasOwnProperty(globaldata.addButton3Name) && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
            }${globaldata.permission}`] === true
            ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
            {customerIds && pageLayoutData[1].title1 == globaldata.delivery ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : ( cookies.get("customer_id") === "17" && (value?.status === "Dispatched" || value?.status === "Intransit")) ? "" : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
            : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
            {(cookies.get("customer_id") == 17 && value.fifo_flag == 1 && value.status === "Pending") && <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon" />}
          {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
          {(value.po_type === 'Reclamation PO') &&
            <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
            <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
            <i style={{color: 'rgb(255, 0, 0, 1)',fontSize: "17px", cursor: 'pointer'}} className="fa fa-info-circle"></i></Tippy>}
            {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
            {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
            {(pageLayoutData[1].title1 === "Returns" && value.status === "Pending") &&
            (<>
                <button className='approve_btn'
                  onClick={() => handleTakeAction(value,1,"approve")} >
                  Approve
                </button>
                &nbsp;
              <button className='reject_btn'
                onClick={() => handleTakeAction(value,2,"reject")} >
                  Reject
              </button>
            </>)}
      </div>;
      if(value.image){
        value.image = <div>
         <img src={value.image} alt="no img" width="50" height="50" />
         </div>;
       }
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const fetchDispatchTimestamp = async () => {
    try{
    const queryParams = {
      type: `${pageLayoutData[1].title1} ${pageLayoutData[1].title2}`
    }
    const paramsConverted = new URLSearchParams(queryParams);
    const timestampEndpoint = `${pageLayoutData[0].timestampApi}`;
    const getURL = (`${timestampEndpoint}?${paramsConverted.toString()}`);
    const response = await FetchAPI(getURL);
    handleNetworkErrors(response,setHasError);
    const responseJson = await response.json();
    if (responseJson?.response?.status === 1) {
      setTimeStamp(responseJson.response.time);
    }else{
      setTimeStamp("");
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  useEffect(() => {
    (async () => {
      try{
      // setformValues(pageLayoutData[0].formValues);
      (pageLayoutData[0].filterStatus == true && setformValues(pageLayoutData[0].formValues));
      if (pageLayoutData !=  globaldata.unDefined) {
        if(pageLayoutData[0].filterStatusDefault === true)
        setshowFilter(true);
        else
        setshowFilter(false);
        setloadTableData(false);
        setsearchInputValue('');
        setshowCSearch(false);
        setpage(1);
        setSelectedValue(1);
        setIsLoading(true);
        setShowParentContent(true);
        let totalParams;
        let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
        }
        totalParams = {...totalParams, ...dynamicParameters}
        if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          handleNetworkErrors(responseData,setHasError)
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            let newArray = []
            for (let i = 0; i < responseDataJson.data.data.length; i++) {
              if (responseDataJson.data.data[i]?.childData?.length === 0) {
                newArray.push(responseDataJson.data.data[i].name);
              }
            }
            setAddButtonPermission(responseDataJson.data.addPermission)
            setAddPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission1(responseDataJson.data[`assign${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission2(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name}Permission`])
            setAddPermission3(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName4') && pageLayoutData[0].addButtonName4.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName4.replace(/\s+/g, '') : pageLayoutData[0].addButtonName4}Permission`])
            setAddPermission4(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName2') && pageLayoutData[0].addButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName2.replace(/\s+/g, '') : pageLayoutData[0].addButtonName2}Permission`])
            setAddChildPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName}Permission`])
            setimportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setimportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setimportPermission2(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName2') && pageLayoutData[0].importButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName2.replace(/\s+/g, '') : pageLayoutData[0].importButtonName2}Permission`])
            setimportPermission3(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName3') && pageLayoutData[0].importButtonName3.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName3.replace(/\s+/g, '') : pageLayoutData[0].importButtonName3}Permission`])
            setexportPermission(responseDataJson.data[`exportPermission`])
            setexportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setexportPermission2(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName2') && pageLayoutData[0].exportButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName2.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName2}Permission`])
            setexportPermission3(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName3') && pageLayoutData[0].exportButtonName3.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName3.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName3}Permission`])
            setBulklistPermission(responseDataJson.data.bulkPicklistPermission)
            setMasterDeliveryPermission(responseDataJson.data.masterDeliveryPermission)
            setAddLocationPermission(responseDataJson?.data?.addLocationPermission)
            setArray([...new Set(newArray)])
            setResponse(responseDataJson.data.data)
            if(pageLayoutData[0].addButtonType =='buildmodal'){
              buildActions(responseDataJson.data)
            }else if(!isEmpty(responseDataJson.data.data)) {
              featureActions(responseDataJson.data)
            }
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)  
            setColumns(responseDataJson.data.columns);
            setproductsData(responseDataJson.data.data);
            setWareIds(responseDataJson?.data?.ware_id)
            setformValues(pageLayoutData[0].formValues);
            setInvValidation(responseDataJson.data.deliveryInventoryValidation);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setPageStartFrom(1)
            setloadTableData(true);
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('alert.wrong');
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          handleNetworkErrors(responseData,setHasError);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
            let newArray = []
            for (let i = 0; i < responseDataJson.data.data.length; i++) {
              if (responseDataJson.data.data.hasOwnProperty[globaldata.childData] && responseDataJson?.data?.data[i]?.childData?.length === 0) {
                newArray.push(responseDataJson.data.data[i].name);
              }
            }
            setAddButtonPermission(responseDataJson.data.addPermission)
            setAddPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission1(responseDataJson.data[`assign${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission2(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name}Permission`])
            setAddPermission3(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName4') && pageLayoutData[0].addButtonName4.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName4.replace(/\s+/g, '') : pageLayoutData[0].addButtonName4}Permission`])
            setAddPermission4(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName2') && pageLayoutData[0].addButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName2.replace(/\s+/g, '') : pageLayoutData[0].addButtonName2}Permission`])
            setAddChildPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName}Permission`])
            setimportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setimportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setimportPermission2(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName2') && pageLayoutData[0].importButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName2.replace(/\s+/g, '') : pageLayoutData[0].importButtonName2}Permission`])
            setexportPermission(responseDataJson.data[`${exportPermission}`])
            setexportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setexportPermission2(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName2') && pageLayoutData[0].exportButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName2.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName2}Permission`])
            setexportPermission3(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName3') && pageLayoutData[0].exportButtonName3.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName3.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName3}Permission`])
            setBulklistPermission(responseDataJson.data.bulkPicklistPermission);
            setMasterDeliveryPermission(responseDataJson.data.masterDeliveryPermission);
            setAddLocationPermission(responseDataJson?.data?.addLocationPermission)
            setArray([...new Set(newArray)])
            setResponse(responseDataJson.data.data)
            if(pageLayoutData[0].addButtonType =='buildmodal'){
              buildActions(responseDataJson.data)
            }else if(!isEmpty(responseDataJson.data.data)) {
              featureActions(responseDataJson.data)
            }
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setColumns(responseDataJson.data.columns);
            setproductsData(responseDataJson.data.data);
            // setformValues(pageLayoutData[0].formValues);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setloadTableData(true);
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('alert.wrong');
          }
        }
        setloadTableData(true);
        setIsLoading(false);
      }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
    })()
    /*inventory report timestamp*/
    if (pageLayoutData != 'undefined') {
      try{
      let dispatchTimestampInterval;
      if (pageLayoutData[0]?.timestampApi) {
        fetchDispatchTimestamp();
        dispatchTimestampInterval = setInterval(() => {
          fetchDispatchTimestamp();
        }, 5 * 60 * 1000)
      }
      return () => {
        clearInterval(dispatchTimestampInterval);
        setTimeStamp("");
      }
      } catch (e) {
        setHasError({
          error: true,
          message: e
        })
      }
  }
  }, [pageLayoutData])

  useEffect(() => {
    try{
    if (globalLoadIndicator == '2' && cookies.get("pagetype_id") == 4
    && featureBlueprint.data.featureBlueprintymlData.pageTypes[0].pageTypeId == 4)
     {
     if((pageLayoutData[1].title1 && 
      pageLayoutData[1].title1 == featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout[1].title1)) {
      setPageLayoutData(pageLayoutDataContext);
      }
      else {
        if(pageLayoutData[1].title1 !==  globaldata.location)
        setPageLayoutData(pageLayoutDataContext);
      }
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData( globaldata.unDefined);
    } 
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [globalLoadIndicator]);

  useEffect(() => {
    try {
      options.page = selectedValue;
      setpage(selectedValue);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [selectedValue]);

  useEffect(() => {
    setSelectedValue(page);
    setPageStartFrom(1)
  }, []);

  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [page]);


  
  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: page,
    totalSize: totalrecords
  }
  

  async function expandRowTable(key) {
    try{
      if (pageLayoutData[1].title1 === "Delivery") {
        const getActiveRow = productsData.filter(row => row.name === key)[0]
        if("parentData" in getActiveRow){
        setExpandTableLoader(false)
        setExpColumns(getActiveRow?.parentData?.columns);
        setExpData(getActiveRow?.parentData?.data)
        setExpRowTotalrecords(getActiveRow?.parentData?.length)
        }
        return;
      }
    setKey(key)
    setExpPage(1)
    setExpandTableLoader(true)
    let payLoad = {}
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      payLoad = { ...payLoad, ...extraParameteres }
    }
    if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      payLoad = { ...payLoad, ...firstTimeParameters }
    }

    let fmData = serachFliterBoxData(values);
    payLoad = { ...payLoad, ...dynamicParameters,...fmData }

    if(response){
      for (let i = 0; i < response.length; i++) {
        if (response[i].name === key) {
          payLoad = {
            ...payLoad,
            specificProductId: response[i].productId,
            specificLocationId: response[i].locationId,
          }
        }
      }
    }
    let responseData = await PostAPI(getURL, payLoad);
    handleNetworkErrors(responseData,setHasError);
    if (responseData.status == 200) {
      let responseDataJson = await responseData.data;
      setExpandTableLoader(false)
      setExpColumns(responseDataJson.data.columns);
      setExpData(responseDataJson.data.data)
      setExpRowTotalrecords(responseDataJson.data.expandRowTotalrecords)
    }
    else {
      setError(true);
      setErrorMsg('alert.wrong');
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  async function expandChildRowTable(key) {
    try{
    if(pageLayoutData[1].title1 === "Delivery"){
      return;
    }
    setExpandChildTableLoader(true)
    setExpChildPage(1)
    let payLoad = {}
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      payLoad = { ...payLoad, ...extraParameteres }
    }
    if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      payLoad = { ...payLoad, ...firstTimeParameters }
    }

    
    let fmData = serachFliterBoxData(values);
    payLoad = { ...payLoad, ...dynamicParameters,...fmData }


    for (let i = 0; i < expandData.length; i++) {
      if (expandData[i].name === key) {
        payLoad = {
          ...payLoad,
          ...fmData,
          specificProductId: expandData[i].productId,
          specificLocationId: expandData[i].locationId,
          mfg_date: expandData[i].mfg_in
        }
      }
    }
    let responseData = await PostAPI(getURL, payLoad);
    handleNetworkErrors(responseData,setHasError);
    if (responseData.status == 200) {
      let responseDataJson = await responseData.data;
      setExpandChildTableLoader(false)
      setExpChildColumns(responseDataJson.data.columns);
      setExpChildData(responseDataJson.data.data)
      setExpChildRowTotalrecords(responseDataJson.data.recordsTotal)
      setKey1(key)
      setExpRes(expChildData);
    }
    else {
      setError(true);
      setErrorMsg('alert.wrong');
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleTableChange1 = (event, { page, sizePerPage }) => {
    try{
    const currentIndex = (page - 1) * sizePerPage;
    setExpPage(page);
    setExpSizePerPage(sizePerPage);
    handleLatestTableData1(page);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

async function handleLatestTableData1(page) {
  try{
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let payLoad = {}
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1;
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = { ...totalParams, ...extraParameteres }
    }
    totalParams = { ...totalParams, ...dynamicParameters }
    let fmData = serachFliterBoxData(values);
    if (page == 1) {
        let startFrom = 0;
        totalParams.start_from = startFrom;
    } else {
        cpage = page - 1;
        startFrom = cpage * expSizePerPage;
        totalParams.start_from = startFrom;
    }
    let newObj = { ...fmData, ...totalParams}
    let newestObjSearch;
    let newestObj = { ...newObj, index: page }
    for (let i = 0; i < response.length; i++) {
      if (response[i].name === key) {
        payLoad = {
          ...payLoad,
          specificProductId: response[i].productId,
          specificLocationId: response[i].locationId,
        }
      }
    }
  newestObjSearch = {
    ...newestObj,
    ...payLoad,
  }
    let responseData = await PostAPI(getURL, newestObjSearch);
    handleNetworkErrors(responseData,setHasError);
    let responseDataJson = responseData.data;
    if (responseData.status == 200) {
        setError(false);
        let responseDataJson = responseData.data;
        setExpColumns(responseDataJson.data.columns);
        setExpData(responseDataJson.data.data)
        setExpRowTotalrecords(responseDataJson.data.expandRowTotalrecords)
    }
    else {
        setError(true);
        setErrorMsg('alert.wrong');
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

const handleTableChange2 = (event, { page, sizePerPage }) => {
   try{
  const currentIndex = (page - 1) * sizePerPage;
  setExpChildPage(page);
  setExpChildSizePerPage(sizePerPage);
  handleLatestTableData2(page);
   } catch (e) {
    setHasError({
        error: true,
        message: e
    })
}
}

async function handleLatestTableData2(page) {
  try{
  let startFrom = 0;
  let cpage = 0
  const searchFormData = {};
  let payLoad = {}
  let totalParams;
  let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = { ...totalParams, ...extraParameteres }
    }
  totalParams = { ...totalParams, ...dynamicParameters }
  let fmData = serachFliterBoxData(values);
  if (page == 1) {
      let startFrom = 0;
      totalParams.start_from = startFrom;
  } else {
      cpage = page - 1;
      startFrom = cpage * expChildSizePerPage;
      totalParams.start_from = startFrom;
  }
  let newObj = { ...fmData, ...totalParams}
  let newestObjSearch;
  let newestObj = { ...newObj, index: page }
  for (let i = 0; i < expandData.length; i++) {
    if (expandData[i].name === key1) {
      payLoad = {
        ...payLoad,
        specificProductId: expandData[i].productId,
        specificLocationId: expandData[i].locationId,
        mfg_date: expandData[i].mfg_in
      }
    }
  }
newestObjSearch = {
  ...newestObj,
  ...payLoad,
  element: searchInputValue,
}
  let responseData = await PostAPI(getURL, newestObjSearch);
  handleNetworkErrors(responseData,setHasError);
  let responseDataJson = responseData.data;
  if (responseData.status == 200) {
      setError(false);
      let responseDataJson = responseData.data;
      setExpChildColumns(responseDataJson.data.columns);
      setExpChildData(responseDataJson.data.data)
      setExpChildRowTotalrecords(responseDataJson.data.recordsTotal)
      setExpRes(expChildData);
  }
  else {
      setError(true);
      setErrorMsg('alert.wrong');
  }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const alertNodeInfo = ({ node, path, treeIndex }) => {
    const objectString = Object.keys(node)
      .map(k => (k === "children" ? "children: Array" : `${k}: '${node[k]}'`))
      .join(",\n   ");
  
    global.alert(
      "Info passed to the button generator:\n\n" +
        `node: {\n   ${objectString}\n},\n` +
        `path: [${path.join(", ")}],\n` +
        `treeIndex: ${treeIndex}`
    );
  };

  const updateTreeData = (data) => {
    try {
      setChangeTreeValue(true);
      setTreevalue([...data]);
      setTimeout(() => {
      }, 2000);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const paginationOption = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: expSizePerPage,
    page: expPage,
    totalSize: expandRowTotalrecords
  }

  const expPaginationOption = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: expChildSizePerPage,
    page: expChildPage,
    totalSize: expandChildRowTotalrecords
  }
  const expandRow = {
    renderer: (data) => {
      let row = data.original;
      return (
        <div>
          {row.hasOwnProperty(globaldata.childData) && childRow !== row.name && setChangeTreeValue(false)}
          {row.hasOwnProperty(globaldata.childData) && changeTreeValue === false && setTreevalue(row.childData)}
          {row.hasOwnProperty(globaldata.childData) && changeTreeValue === true && setTreevalue((prevState) => prevState)}
          {row.hasOwnProperty(globaldata.childData) && setChildRow(row.name)}
  
          <p>{row.hasOwnProperty(globaldata.childData) && row.attributeSetName}</p>
  
          {row.hasOwnProperty(globaldata.childData) && Object.keys(row.childData).length > 0 ? (
            <CommonTree
              treeData={row.childData}
              row={row}
              addChild={addChild}
              opneEditParent={opneEditParent}
              deleteOpenModal={deleteOpenModal}
              deleteParentPassword={deleteParentPassword}
              deleteChildPassword={deleteChildPassword}
              restoreChild={restoreChild}
              searchableChild={searchableChild}
              pageLayoutData={pageLayoutData}
            />
          ) : row.hasOwnProperty(globaldata.binLocation) === false ? (
            expandTableLoader ? (
              <div className="text-center" style={{ ...centeredDiv, height: '13vh' }}>
                <LoadingSpinner />
              </div>
            ) : (
              <div
                className={`${pageLayoutData[1].title1 === 'Delivery' ? 'delivery-pagination' : ''}`}
              >
                {data.getIsExpanded() ? (
                  <ExpandRowGrid
                    pageLayoutData={pageLayoutData}
                    serachFliterBoxData={serachFliterBoxData}
                    dynamicParameters={dynamicParameters}
                    response={response}
                    row={row}
                    values={values}
                    pagination={pagination}
                    setPagination={setPagination}
                    title={pageLayoutData[1].title1 === 'Delivery' ? null : `Ageing ${pageLayoutData[1].title2}`}
                    productsData={productsData}
                    expandRow={expandRow}
                  />
                ) : null}
              </div>
            )
          ) : (
            <span>No data</span>
          )}
        </div>
      );
    },
  };
  
  const openImport = () => {
    try{
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].importButtonItems.className)
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  const openImport1 = () => {
    try{
    setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].importButtonItems1.className)
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const openImport2 = () => {
    try{
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName2);
    setModalformValues(pageLayoutData[0].importButtonItems2.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems2.saveApiEndPoint);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}
const openImport3 = () => {
  try{
  setModalWidth('modal-55w') // setModalWidth(pageLayoutData[0].importButtonItems3.className)
  setmodalType(`${t("import")}`);
  setModalTitle(pageLayoutData[0].importButtonName3);
  setModalformValues(pageLayoutData[0].importButtonItems3.formValues);
  setSaveUrl(pageLayoutData[0].importButtonItems3.saveApiEndPoint);
  setshowModal(true);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  
  async function exportFile(e,name) {
    try{
    e.preventDefault();
    setIsLoader(true)
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val =  globaldata.unDefined;
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get(globaldata.userId),
      customer_id:cookies.get(globaldata.customerId),
      email:localStorage.getItem(globaldata.email),
      language:language
    }
    const getURL = (pageLayoutData[0].exportApiEndPoint) ? pageLayoutData[0].exportApiEndPoint 
    : (name === pageLayoutData[0].exportButtonName1) ? pageLayoutData[0].exportApiEndPoint1 
    : (name === pageLayoutData[0].exportButtonName2) ?  pageLayoutData[0].exportApiEndPoint2
    : (name === pageLayoutData[0].exportButtonName3) ?  pageLayoutData[0].exportApiEndPoint3
    : globaldata.notFound;
    let newgetURL,getresponse,dataObject;
    dataObject = {
      ...requiredValues
    }
    if(val !==  globaldata.unDefined) {
      let fmData = serachFliterBoxData(values);
      let customerId = cookies.get(globaldata.customerId);
      if (customerId == 13 && fmData.from_date != null && fmData.to_date == null) {
        swal({ title: globaldata.failed, text: `${t('alert.selectToDate')}`, icon:  globaldata.error, button: `${t("alerts.ok")}` })
        return
      }
      if (customerId == 13 && (fmData.from_date != null && fmData.to_date == null) || fmData.from_date == null && fmData.to_date != null) {
        swal({ title: globaldata.failed, text: `${t('alert.selectFromDate')}`, icon:  globaldata.error, button: `${t("alerts.ok")}` })
        return
      }
      dataObject = {...dataObject, ...fmData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError)
        setIsLoader(false);
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
        handleNetworkErrors(getresponse,setHasError);
        setIsLoader(false);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === globaldata.GET) {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        let getresponseJson = await getresponse.json()
        window.location.href = getresponseJson?.data?.Location
        setIsLoader(false)
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
        handleNetworkErrors(getresponse,setHasError);
      }
    }
    if(getresponse.status == 200){
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:globaldata.success, button:`${t("alerts.ok")}`})
      name && (window.location.href = getresponse?.data?.data?.Location)
    }
    else{
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon: globaldata.error, button:`${t("alerts.ok")}`})
    }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
}

  const handlePageChange = (e) => {
    try {
      setSelectedValue(e.target ? e.target.value : e);
      handleLatestTableData(e.target ? e.target.value : e);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  columns.forEach((item)=>{
    item.text=t(item.text) 
    item.style = {textAlign: "left"}
  })

  async function filteredExport1(data) {
    setIsFilterLoader(true);
    let arr = Object.values(data);
    let valueNull = arr.some((el) => el.value !== null)
    let datesNull = true;
    Object.keys(data).forEach(el => {
      if(el==='from_date' || el==='to_date'){
        if(data[el].value === null)
          datesNull = false
      }
    })
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint1;
    if(cookies.get('customer_id') === "17" && pageLayoutData[1].title1 === "Inventory"){
      getURL = pageLayoutData[0].exportApiEndPoint3
    }
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    totalParams = {...totalParams, ...requiredValues}
    // let getURL = pageLayoutData[0].exportApiEndPoint1+'?customer_id='+cookies.get('customer_id') 
    // + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email');
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if (data[formElementIdentifier].elementType === 'multiselect') {
        if ((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function (fValue, indexId) {
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
      }
      else if (data[formElementIdentifier].elementType === 'selectshowsearch') {
        if ((data[formElementIdentifier].value)) {
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value?.value
        }
      }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    
    let newObj = { ...searchFormData, ...totalParams}
    // commenting logic for validation for selecting in filter 
    // let noFilterFlag = true;
    // for(let field in searchFormData){
    //   if(searchFormData[field]){
    //     noFilterFlag = false;
    //   }
    // }
    // if(noFilterFlag){
    //   return swal({
    //     title:`${t("alerts.choose_valid_dates")}`, 
    //     text: combinedTitle,
    //     icon:"warning", button:`${t("alerts.ok")}`
    //   })
    // }
    const responseData = await PostAPI(getURL,newObj)
    setIsFilterLoader(false);
    if(responseData.data.data?.Location){
      window.location.href = responseData.data.data?.Location
    }else if(responseData.data.data?.Status === 200){
      swal({
        icon: 'success',
        title: responseData.data.data?.Message
      })
      window.location.href = responseData.data.data?.data?.Location
      return;
    }
    else if(responseData.data.data?.Status == 409){
      let msg = responseData.data.data?.Message;
      return swal(msg.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
        icon: "info",
        buttons: `${t('alerts.ok')}`,
        dangerMode: true,
      })
    }
    else{
      return swal({icon: "warning",text: responseData.data.data.message})
    }
}

const handleAddLocation = (event, data) => {
  let inputValues = pageLayoutData[0].addButtonParentItems.formValues
  try{
  setmodalType(`${t(globaldata.add)}`);
  setModalTitle(pageLayoutData[0].addButtonParentName);
  setCommonTitle(pageLayoutData[0].addButtonParentName)
  setModalWidth('modal-55w') 
  setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
  setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId)+`&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.language}=`+language)
  setshowModal(true);
  (pageLayoutData[1].title1 === 'Location' ? conditionalBasedInputValue(inputValues) : setModalformValues(inputValues))

  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  const handleOnSelectRow = (row,isSelect) => {
    if(isSelect){
      setIsSelectedRow([...isSelectedRow,row.name])
    }else{
      setIsSelectedRow(isSelectedRow.filter(selected => selected !== row.name))
    }
  }
  
  const getNonSelectable = () => {
    if(productsData?.length > 0){
       return productsData.map(product => {
        if(product.status !== "Pending"){
          return product.name
        }
      })
    }
  }

  const selectRow = {
    mode: 'checkbox',
    onSelect: handleOnSelectRow,
    nonSelectable: getNonSelectable(),
    hideSelectAll: true,
    selected: isSelectedRow
  };

  const handleMasterDelivery = async() => {
    try{
      const getSelectedRows = productsData.filter(delivery => delivery.master_delivery === 1)
      for(let value of getSelectedRows){
        if(isSelectedRow.includes(value.name)){
          getStatusAlert({status: 0,message: "Master delivery already created for selected deliveries."})
          return;
        }
      }
      const payload = {
        delivery_ids: isSelectedRow,
        user_id:cookies.get("user_id"),
      }
      const getURL = pageLayoutData[0].exportEndPoint2;
      setIsLoader(true);
      const response = await PostAPI(getURL, payload);
      setIsLoader(false);
      handleNetworkErrors(response,setHasError);
      if(response?.data?.data?.status !== 0){
        setIsSelectedRow([]);
      };
      getStatusAlert({
        status: response?.data?.data?.status,
        message: response?.data?.data?.message,
        reCallGrid: getLatestTableData,
    })
      
    }catch(e){
      setHasError({
        error: true,
        message: e
      })
    }
  }
  
  const handleSelectRow = async () => {
    try{
      const getSelectedRows = productsData.filter(delivery => delivery.master_delivery === 1)
      let count = 0
      for(let value of getSelectedRows){
        if(isSelectedRow.includes(value.name)){
          count++
          if(count === 2){
            getStatusAlert({status: 0,message: "Please select only one master delivery."})
            return;
          }
        }
      }
    const payload = {
      delivery_ids: isSelectedRow
    }
    const getURL = pageLayoutData[0].exportEndPoint1;
    const responseData = await PostAPI(getURL, payload);
    handleNetworkErrors(responseData,setHasError);
    const url = responseData.data.data
    handleLatestTableData(page)
    setIsSelectedRow([])
    const link = document.createElement('a');
    link.target = '_self';
    link.href = url;
    link.setAttribute(globaldata.download, url);
    link.click();
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  } 

  const handleAddFromSAP = () => {
    setshowFilter(!showFilter)
    setformValues(pageLayoutData[0].addSapProductFormValues.formValues)
  }

  const handleSubmitClick = async(validator,showValidationMessage,filterFormValues,setloadSForm) => {
    if (validator.allValid()) {
        const endpoint = `https://login-stg.${subDomain}:3004/sap-products-management/createProduct`;
        const payloadObj = {}
        for(let identifier in filterFormValues){
          payloadObj[identifier] = filterFormValues[identifier].value
        }
        payloadObj["creation_date"] = moment(payloadObj["creation_date"]).format("YYYYMMDD");
        const [time_from, time_to] = payloadObj["time_range"]
        payloadObj["time_from"] = moment(time_from).format("HHmmss");
        payloadObj["time_to"] = moment(time_to).format("HHmmss");
        delete payloadObj["time_range"]
        setloadSForm(true);
        const response = await PostAPI(endpoint,payloadObj)
        if(response.status === 200){
          if(response.data.Status === 1){
            swal({icon: "success",text: response.data.Message})
          }else{
            swal({icon: "warning",text: response.data.Message})
          }
          setloadSForm(false);
        }else{
          swal({icon: "error",text: "Something went wrong!"})
          setloadSForm(false);
        }
    }else{
        showValidationMessage(true);
    }
}

const handleMergeDeliveries = async() => {
  const endpoint = pageLayoutData[1].subComponentsItems.mergeEndpoint;
  const payload = {
    ...dynamicParameters,
    delivery_ids: selectedRows
  }
  const response = await PostAPI(endpoint, payload);
  if(response.status === 200) {
    if(response.data.data.Status === 1){
      swal({icon: "success",text: response.data.data.Message})
      setSelectedRows([])
      getLatestTableData()
    }else{
      swal({icon: "warning",text: response.data.data.Message})
    }
  }
}

const handleUnmergeDeliveries = () => {
  swal("Please Enter Master TP Number", {
    content: "input",
    buttons: {
      confirm: {
        text: "Submit"
      },
      cancel: "Close"
    }
  }).then((value) => {
    if(value === null){
      return;
    }
    if (!value || value.trim() === "") {
      swal("Error", "Master TP Number is required!", "error");
      return;
    }else if (!/^\d{16}$/.test(value)) {
      swal("Error", "Master TP Number must be 16 digits numeric!", "error");
      return;
    }
    else{
    swal({
      text: `Are you sure you want to unmerge Master TP Number ${value} ?`,
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Unmerge"
        }
      }
    }).then(async(unmerge) => {
      if (unmerge) {
        const endpoint = pageLayoutData[1].subComponentsItems.unMergeEndpoint
        const payload = {
          ...dynamicParameters,
          master_tp: value,
          delivery_ids: selectedRows
        }
        const response = await PostAPI(endpoint, payload)
        if (response.status === 200) {
          if(response.data.data.Status === 1){
            swal({icon: "success",text: response.data.data.Message})
            setSelectedRows([])
            getLatestTableData()
          }else{
            swal({icon: "warning",text: response.data.data.Message})
          }
        }
      }
    })
  }
  });
}
const handleRowSelectionChange = (event, row) => {
  const isChecked = event.target.checked;
  if (isChecked) {
    setSelectedRows(prevState => [...prevState, row.name]);
  } else {
    setSelectedRows(prevState => prevState.filter(item => item !== row.name));
  }
};

const isRowSelected = (row) => {
  return selectedRows.includes(row.name);
};

const getRowData = (data) => {
  if ((cookies.get("customer_id") == 17 || cookies.get("customer_id") == 15) && pageLayoutData[1].title1 === "Delivery") {
    return data.map((row) => {
      row.rowSelect = (
        <input
          type="checkbox"
          checked={isRowSelected(row)}  
          onChange={(event) => handleRowSelectionChange(event, row)}
          disabled={
            cookies.get("customer_id") == 17 && row.status === "Intransit" && !row.master_tp
              ? false
              : cookies.get("customer_id") == 15 && row.status === "Pending"
              ? false
              : true
          }
        />
      );
      return row;
    });
  } else {
    return data;
  }
};
  
  if (hasError.error) {
    return <ErrorFallback error={hasError.message} />
  }  
  return (
    (pageLayoutData !=  globaldata.unDefined && cookies.get(globaldata.pageTypeId) == 4) ?
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                title={(pageLayoutData[1].title1) ? t(pageLayoutData[1].title1 ): ''}
                title2={( pageLayoutData[1].title2) ? t(pageLayoutData[1].title2) : ''}
                timeStamp={timeStamp}
                content={
                  <div>
                  {showParentContent ?
                      <>
                          <Row>
                          <Col md="12" className="mb-12">                            
                              <div className="button-container" >
                                {/* <MyExportCSV {...props.csvProps} /> */}
                                {/* <ExportCSVButton {...props.csvProps}>Export CSV!!</ExportCSVButton> */}
                                {pageLayoutData[1].subComponentsItems.mergeButton && <ButtonField color="info" disabled={selectedRows?.length < 2} submit={() => handleMergeDeliveries()} BName="Merge TP" />}
                                {pageLayoutData[1].subComponentsItems.unMergeButton &&<ButtonField color="info"  submit={() => handleUnmergeDeliveries()} BName="Unmerge TP" />}
                                {masterDeliveryPermission && <ButtonField color="info" disabled={isSelectedRow?.length < 2}  submit={(e) => handleMasterDelivery(e)} BName={"Master Delivery"} />}
                                {bulkPicklistPermission && <ButtonField color="info" disabled={isSelectedRow?.length < 1}  submit={(e) => handleSelectRow(e)} BName={"Bulk Picklist"} />}
                                {(pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'buildmodal' && (addButtonPermission == true) ) ? <ButtonField color="info" submit={() => buildModal()} BName={`${t("Build/Software")} `} /> : ''}
                                {(pageLayoutData[0].exportButton === true || exportPermission === true)  ? <ButtonField color="info"  type={t("export")} submit={(e) => exportFile(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[0].exportButton1 === true || exportPermission1 === true) ? <ButtonField color="info"  type={t("export")} submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName1)} BName={`${t("export")} `+ t(pageLayoutData[0].exportButtonName1)} /> : ''}
                                {(pageLayoutData[0].exportButton2 === true || exportPermission2 === true) ? <ButtonField color="info"  type={t("export")} submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName2)} BName={`${t("export")} `+ t(pageLayoutData[0].exportButtonName2)} /> : ''}
                                {(pageLayoutData[0].exportButton3 === true || exportPermission3 === true) ? <ButtonField color="info"  type={t("export")} submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName3)} BName={`${t("export")} `+ t(pageLayoutData[0].exportButtonName3)} /> : ''}
                                {((pageLayoutData[0].addButton === true || addPermission === true) && (pageLayoutData[0].addButtonType !== 'wizard' && pageLayoutData[0].addButtonType !== 'buildmodal')) ? <ButtonField color="info" type={t("add")} submit={() => open()} BName={t(pageLayoutData[0].addButtonName)} /> : ''}
                                {(pageLayoutData[0].addButtonChild === true || addChildPermission === true) ? <ButtonField type={`${t("add")}`} color="info" submit={() => openChild()} BName={t(pageLayoutData[0].addButtonChildName)} /> : ''}
                                {/*Assign Category*/}{((pageLayoutData[0].addButton === true || addPermission1 === true) && pageLayoutData[0].addButtonType == 'wizard') ?  <ButtonField color="info" type={t("assign")} submit={() => openComponent()} BName={`${t("assign")} `+ t(pageLayoutData[0].addButtonName)} /> : ''}
                                {/*Add Product*/}{((pageLayoutData[0].addButton2 === true || addPermission2 === true) && pageLayoutData[0].addButtonType == 'wizard') ?  <ButtonField color="info" type={t("add")} submit={() => openComponent1()} BName={t(pageLayoutData[0].addButton3Name)} /> : ''}
                                {/*Add Location*/}{(pageLayoutData[0].addButton3 === true || addPermission3 === true) ? <ButtonField color="info" type={t("add")} submit={() => openLocation()} BName={t(pageLayoutData[0].addButtonName4)} /> : ''}
                                {/*Add BusinessUnit*/}{(pageLayoutData[0].addButton4 === true || addPermission4 === true) ? <ButtonField color="info" type={t("add")} submit={() => openBusinessUnit()} BName={t(pageLayoutData[0].addButtonName2)} /> : ''}
                                {(pageLayoutData[0].filterStatus === true) ? <ButtonField color="info"  type={t("filter")} key="Filter" submit={() => setshowFilter(!showFilter)} BName={`${t("filter")}`} /> : ''}
                                {(pageLayoutData[0].importButton === true || importPermission === true) ? <ButtonField color="info" type={t("import")} submit={() => openImport()} BName={t(pageLayoutData[0].importButtonName)} /> : ''}
                                {(pageLayoutData[0].importButton1 === true || importPermission1 === true) ? <ButtonField color="info" type={t("import")} submit={() => openImport1()} BName={t(pageLayoutData[0].importButtonName1)} /> : ''}
                                {(pageLayoutData[0].importButton2 === true || importPermission2 === true) ? <ButtonField color="info" type={t("import")} submit={() => openImport2()} BName={t(pageLayoutData[0].importButtonName2)} /> : ''}
                                {(pageLayoutData[0].importButton3 === true || importPermission3 === true) ? <ButtonField color="info" type={t("import")} submit={() => openImport3()} BName={t(pageLayoutData[0].importButtonName3)} /> : ''}
                                {(pageLayoutData[0].addSapProduct) && <ButtonField color="info" type={t("add")} submit={() => handleAddFromSAP()} BName="Product from SAP" />}
                                {(pageLayoutData[0].addLocationButton && addLocationPermission) && <ButtonField color="info" type={t("add")} submit={() => handleAddLocation()} BName="Location" />}
                                {showModal ?
                                  <ModalBox
                                    key={ pageLayoutData[0].featureId }
                                    showModal={showModal}
                                    titlePreFix = { modalType }
                                    // title={pageLayoutData[0].addButtonName}
                                    modalWidth = { modalWidth}
                                    uniqueid={ uniqueid }
                                    title={ modalTitle }
                                    title1 = {title1}
                                    formValue={ ModalformValues }
                                    addURL=  { saveUrl } //{ pageLayoutData[0].addButtonItems.saveEndPoint }
                                    getURL={ modalgetURL }
                                    product_id_old = {productId}
                                    delivery_id = {deliveryId}
                                    commonTitle = {commonTitle}
                                    location_type_id = {locationTypeId}
                                    location_id = {locationId}
                                    permission = {invValidation}
                                    recallMehod = { getLatestTableData }
                                    drpdwnApi = { dropDownApi }
                                    extraId = {extraId}
                                    wareId = {wareId}
                                    wareIds = {wareIds}
                                    headers = {headers}
                                    table = {table}
                                    val1 = {val1}
                                    val2 = {val2}
                                    dyn_template = {pageLayoutData[0].importDynamicTemplate}
                                    line = {line}
                                    extracall={ instantValuesUpdateFilterBox }
                                    featureTitle = {i18n.language === "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1}
                                    // modalWidth = {(pageLayoutData[1].title1 === 'Sales Delivery Details' &&
                                    // pageLayoutData[0].addButtonItems.hasOwnProperty('className')) ? 
                                    //   pageLayoutData[0].addButtonItems.className : '' }
                                    // headers = {(pageLayoutData[1].title1 === 'Sales Delivery Details'
                                    // && pageLayoutData[0].addButtonItems.hasOwnProperty('headers')) ? 
                                    // pageLayoutData[0].addButtonItems.headers : '' }
                                    // editHeaders = {(pageLayoutData[1].title1 === 'Sales Delivery Details'
                                    // && pageLayoutData[0].addButtonItems.hasOwnProperty('headers')) ? 
                                    // pageLayoutData[0].addButtonItems.headers : '' }
                                    hide={close}
                                    isDragAndDrop={isDragAndDrop}
                                    isApproved={isApproved}
                                    editId={editId}
                                    buildValue={staticModalformValues}
                                    locationsEndPoint={pageLayoutData[1]?.subComponentsItems?.locationsEndpoint}
                                    setHasError={setHasError}
                                    />
                                  : ''}
                                  {ShowModald3 ?
                                  <ModalTreeBox
                                    key={ pageLayoutData[0].featureId }
                                    showModal={ShowModald3}
                                    treeModalWidth= {pageLayoutData[0].treeModalWidth}
                                    treeHeight= {pageLayoutData[0].treeHeight}
                                    treeWidth= {pageLayoutData[0].treeWidth}
                                    treeLineHeight= {pageLayoutData[0].treeLineHeight}
                                    titlePreFix = { modalType }
                                    title={ modalTitle }
                                    getURL={ modalgetURL }
                                    hide={close} />
                                  : ''}
                              </div>
                            </Col>                            
                          </Row>
                          {showFilter ?
                          <div className="filter-box" >
                            <FilterBox
                             key="FilterBox" 
                             setSelectChildValue={setSelectChildValue}
                             title={pageLayoutData[1].title1}
                             setformValues = { setformValues }
                             formValue={formValues} 
                             filteredExport = {filteredExport}
                             filteredExport2 = {filteredExport2}
                             change={inputChangedHandler} 
                             searchClick={(e) => searchTableData(e)} 
                             clearClick={clearTableData}
                             validate={validator}
                             isFilterLoader={isFilterLoader}
                             exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                              // dropDownApi = {pageLayoutData[0].hasOwnProperty('filterEndPoint') ? pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ cookies.get('userRole_name') : 'not found' } 
                             dropDownApi = {pageLayoutData[0].hasOwnProperty(globaldata.filterEndPoint) ? pageLayoutData[0].filterEndPoint+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId)+`&${globaldata.userLocationId}=`+ cookies.get(globaldata.userLocationId)+ `&${globaldata.userRoleName}=`+ cookies.get(globaldata.userRoleName) +`&${globaldata.language}=`+language + `&${globaldata.startFrom}=`+ headerData.start_from : globaldata.notFound } 
                             addSapProduct={pageLayoutData[0].hasOwnProperty('addSapProduct') ? pageLayoutData[0].addSapProduct : undefined}
                             handleSubmitClick={handleSubmitClick}
                             //isFilterLoader={isFilterLoader}
                             filteredExport1={filteredExport1}
                             exportFilterButton1={pageLayoutData[0].exportFilterButton3 === true}
                            exportFilterButtonName1={
                              pageLayoutData[0].hasOwnProperty('exportFilterButtonName3')
                                ? pageLayoutData[0].exportFilterButtonName3
                                : ''
                            }
                             setHasError={setHasError}
                             />
                            </div>
                            : ''}
                          {/* &&  */}
                          {/* (productsData[0] &&
                          productsData[0].hasOwnProperty(globaldata.childData)) */}
                          <div className={`grid-styles ${totalQuantities?.length > 0 ? "show-total-qty" : ""}`}>
                          <DataGrid
                            rowData={getRowData(productsData)}
                            columns={transformColumns(columns,(pageLayoutData[1].title1 === "Delivery" && cookies.get("customer_id") == "17"))}
                            paginationConfig={{ totalrecords, setPagination, pagination }}
                            rowExpandConfig={{enableRowExpansion: true, expandRow}}
                            isLoading={isLoading}
                            enableRowSelection={false}
                            setIsSelectedRow={setIsSelectedRow}
                            globalSearchConfig={{
                              enableGlobalFilter: pageLayoutData[0].searchOption === true ? true: false,
                              placeholder: pageLayoutData[1].title1,
                              handleGlobalSearch,
                              handleClearSearch
                            }}
                            title={`${pageLayoutData[1].title1} ${pageLayoutData[1].title2}`}
                          />
                              {
                                totalQuantities?.length > 0 && (
                                  <div className="report-qty">
                                    {totalQuantities.map(record => (
                                      <div>{`TOTAL ${record.name}`}&nbsp; <span className="report-qty-color" > {`: ${record.count}`}</span></div>
                                    ))}
                                  </div>
                                )
                              } 
                        </div> 
                            
                  </>
                :
                <>
                     {renderComponent && 
                     <Wizard 
                       setShowParentContent={setShowParentContent} 
                       pageLayoutData={ModalformValues}
                       pageLayoutData1={pageLayoutData[0]} 
                       pageLayoutData2 = {pageLayoutData[1].subComponentsItems}
                       addURL={pageLayoutData[1].subComponentsItems.saveApiEndPoint}
                       getURL={modalgetURL}
                      uniqueId={uniqueId}
                      imagePath={imagePath}
                       locationDropDownAPI={pageLayoutData[1].subComponentsItems.hasOwnProperty(globaldata.getLocationDropdowns) ? pageLayoutData[1].subComponentsItems.getLocationDropdowns+`?${globaldata.customerId}=`+ cookies.get(globaldata.customerId) + `&${globaldata.userId}=`+ cookies.get(globaldata.userId) : globaldata.notFound }
                      // dropDwnApi = {pageLayoutData[0].hasOwnProperty('filterEndPoint') ? pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id') : 'not found' }
                       dropDwnApi = {dropDownApi}
                      featureName={pageLayoutData[0].addButtonName} 
                      wizardTitle =  {pageLayoutData[1].title1 === 'Products' && pageLayoutData[0].addButton3Name}
                       titlePreFix = { modalType } 
                       //productId={productId}
                       recallMethod= { getLatestTableData }
                       showParentContent = {showParentContent}
                      //  setShowParentContent = {setShowParentContent}
                       setformValues = {setformValues}
                       setModalformValues = {setModalformValues}
                       isEditOpen={isEditOpen}
                       setHasError={setHasError}
                       // backCheck={backCheck}
                       // setBackCheck={setBackCheck}
                       // backButtonItems={pageLayoutData[0].backButtonItems}
                     />}
                     
                   </>
                }
                </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
  : null
  )
}

export default Role;